/**
 * クラス名：板金の加工時間画面
 * 作成者：チュー
 * 作成日：2023/06/21
 * バージョン：1.0
 */
import React, { useEffect, forwardRef, useState, useRef } from 'react';
import { Table } from 'react-bootstrap';
import { Row, Col, Input, Checkbox, Space, Button, Radio, Popover } from 'antd';
import { PlusCircleFilled, CloseCircleFilled, CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import { isEmpty } from '@rc-component/mini-decimal/es/numberUtil';

import {
  JPYs,
  TimeInputParameterScreen,
  deleteListColData,
  getInputBorderStyle,
  getMaterialTypeById,
  getProcessDetailTypeName,
  handleKeyPress,
  isDigit,
  isDigitZenkaku,
  regexExp,
  secondsToHms,
  setTimetoSec,
  sortListByMasterData,
  sortListData,
  sortSizeListData,
  toHalfWidth,
  updateList,
  updateListColData,
} from '../../../common/Common';
import { commonModal } from '../../../common/CommonModal';
import { souchiHandleIncreaseTime, souchiHandleDecreaseTime } from '../../../common/Common';
import { WorkType } from '../../../common/enums';
const Device_KakouJikan = forwardRef((props, ref) => {
  const [editMode, setEditMode] = useState(false);
  const [category, setCategory] = useState('');
  const [isLength, setIsLength] = useState(false);
  const [isSizeItaatsu, setIsSizeItaatsu] = useState(false);
  const [isMmItaatsu, setIsMmItaatsu] = useState(false);
  const [isSize, setIsSize] = useState(false);
  const [isAnaSize, setIsAnaSize] = useState(false);

  const [areaData, setAreaData] = useState([]);
  const [detailsAreaTemp, setDetailsAreaTemp] = useState([]);
  const [detailsList, setDetailsList] = useState([]);

  const [mode, setMode] = useState('simple');

  // 加工補正時間係数
  // const [correctionTimeFactorList, setCorrectionTimeFactorList] = useState([]);

  // 簡易入力と詳細入力
  const [sizeData, setSizeData] = useState([]);
  const [sizeDataTemp, setSizeDataTemp] = useState([]);
  const [anaSizeData, setAnaSizeData] = useState([]);
  const [anaSizeDataTemp, setAnaSizeDataTemp] = useState([]);
  const [kaniListData, setKaniListData] = useState([]);
  const [kaniAnaListData, setKaniAnaListData] = useState([]);
  const [kaniMultiProcAnaListData, setKaniMultiProcAnaListData] = useState([]);

  // サイズ板厚マスタ
  const [sizeItaatsu, setSizeItaatsu] = useState([]);
  const [sizeItaatsuTemp, setSizeItaatsuTemp] = useState([]);

  // mm板厚マスタ（成形型穴）
  const [mmItaatsu, setMmItaatsu] = useState([]);
  const [mmItaatsuTemp, setMmItaatsuTemp] = useState([]);

  // 材質区分
  const [zaishitsuData, setZaishitsuData] = useState([]);

  const [btnEnable, setBtnEnable] = useState(true);

  // One by one
  const [flag, setFlag] = useState(false);

  const [cutTime, setCutTime] = useState(0);

  // 工程マスタレコード情報
  const [processMstRecord, setProcessMstRecord] = useState();
  // 入力チェック
  const [errIndexVal, setErrIndexVal] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [isUsedEasyWorkSpeed, setIsUsedEasyWorkSpeed] = useState(false);

  // mm板厚マスタ（多工程穴）
  const [anaSizeMultiProcData, setAnaSizeMultiProcData] = useState([]);
  const [anaSizeMultiProcDataTemp, setAnaSizeMultiProcDataTemp] = useState([]);
  const [mmMultiProcHole, setMmMultiProcHole] = useState([]);
  const [mmMultiProcHoleTemp, setMmMultiProcHoleTemp] = useState([]);
  const [isMultiProcAnaSize, setIsMultiProcAnaSize] = useState(false);

  const inputRef = useRef([]);

  useEffect(() => {
    setErrIndexVal([]);
    setErrorMessage('');
    setEditMode(props.editMode);
    // setCategory(props.processName);
    setCategory(props.processType);

    if (props?.processMstRecord) {
      setProcessMstRecord(props?.processMstRecord);
    }
    if (props?.materialTypes) {
      setZaishitsuData(props?.materialTypes);
    }

    // 自動バリ又表面処理の加工時間
    if (props?.detailsData?.areaThMaster) {
      setAreaData(props?.detailsData?.areaThMaster);
      setDetailsAreaTemp(props?.detailsData?.areaThMaster);
    }
    if (props?.detailsData?.workTimeThItems) {
      setDetailsList(props?.detailsData?.workTimeThItems);
    }

    // サイズ　簡易マスタ
    if (props?.detailsData?.sizeThMaster) {
      setSizeData(props?.detailsData?.sizeThMaster);
      setSizeDataTemp(props?.detailsData?.sizeThMaster);
    }
    // サイズ　詳細の板厚マスタ
    if (props?.detailsData?.sizeThicknessThMaster) {
      setSizeItaatsu(props?.detailsData?.sizeThicknessThMaster);
      setSizeItaatsuTemp(props?.detailsData?.sizeThicknessThMaster);
    }
    // サイズ簡易入力リスト
    if (props?.detailsData?.workTimeSizeThItems) {
      setKaniListData(props?.detailsData?.workTimeSizeThItems); // IQX_WEBEST-296 入力値が保持されるように修正
    }

    // mm（成形型穴）マスタ　簡易入力
    if (props?.detailsData?.mmThMaster) {
      setAnaSizeData(props?.detailsData?.mmThMaster);
      setAnaSizeDataTemp(props?.detailsData?.mmThMaster);
    }
    // mm（多工程穴）マスタ　簡易入力
    if (props?.detailsData?.mmMultiProcHoleThMaster) {
      setAnaSizeMultiProcData(props?.detailsData?.mmMultiProcHoleThMaster);
      setAnaSizeMultiProcDataTemp(props?.detailsData?.mmMultiProcHoleThMaster);
    }
    // 成形型穴　詳細の板厚マスタ
    if (props?.detailsData?.mmThicknessThMaster) {
      setMmItaatsu(props?.detailsData?.mmThicknessThMaster);
      setMmItaatsuTemp(props?.detailsData?.mmThicknessThMaster);
    }
    // 多工程穴　詳細の板厚マスタ
    if (props?.detailsData?.mmThicknessMultiProcHoleThMaster) {
      setMmMultiProcHole(props?.detailsData?.mmThicknessMultiProcHoleThMaster);
      setMmMultiProcHoleTemp(props?.detailsData?.mmThicknessMultiProcHoleThMaster);
    }
    // 成形型穴　詳細入力リスト
    if (props?.detailsData?.workTimeSizeHoleThItems) {
      setKaniAnaListData(props?.detailsData?.workTimeSizeHoleThItems); // IQX_WEBEST-296 入力値が保持されるように修正
    }
    // 多工程穴　詳細入力リスト
    if (props?.detailsData?.workTimeMmMultiProcHoleThItems) {
      setKaniMultiProcAnaListData(props?.detailsData?.workTimeMmMultiProcHoleThItems);
    }

    // 1カット時間
    setCutTime(props?.detailsData?.cutTime);
    // one by one
    setFlag(props?.detailsData?.isOneCut);
    // setCorrectionTimeFactorList(props.correctionTimeFactorListData);
    // 加工速度の簡易入力・詳細入力の初期表示チェック
    // 加工速度の簡易入力・詳細入力の初期表示チェック
    setIsUsedEasyWorkSpeed(props?.detailsData?.isUsedEasyWorkSpeed);
    if (props?.detailsData?.isUsedEasyWorkSpeed) {
      setMode('simple');
    } else {
      setMode('details');
    }
    // if (!props.editMode) {
    //   isDetailDisplay(props?.detailsData?.workTimeSizeThItems, props?.detailsData?.workTimeSizeHoleThItems);
    // }
  }, [
    props.detailsData,
    props.editMode,
    props.processType,
    // props.area,
    props.listData,
    props.iq3SizeMaster,
    props.iq3KaniListData,
    props.mmMaster,
    props.iq3KaniAnaListData,
    props.itaatsu1,
    props.zaishitsu,
    props.cutTime,
    props.shirringflag,
    props?.processMstRecord,
    // props.correctionTimeFactorListData,
  ]);

  // IQX_WEBEST-296 簡易入力と詳細入力を切り替える際には値を引き継げるようにしてほしい
  // useEffect(() => {
  //   let detailDisplay = false;
  //   let workTimeSizeThItems = props?.detailsData?.workTimeSizeThItems;
  //   // 加工種類 / サイズチェック
  //   if (workTimeSizeThItems) {
  //     const usedItems = zaishitsuData?.filter((item) => item.info.isUsed);
  //     Object.keys(workTimeSizeThItems)
  //       .filter(([sizeDataKey]) => getProcessDetailTypeName(parseInt(sizeDataKey), processMstRecord) !== undefined)
  //       ?.map(([typeKey, item], rowIndex) => {
  //         workTimeSizeThItems[typeKey]?.map((item, workTimeSizeIndex) => {
  //           // サイズ
  //           if (item?.workTimeThickThItems) {
  //             let sameVal = item?.workTimeThickThItems[usedItems?.[0]?.id]?.[0]?.value;
  //             usedItems?.map((materialTypeItem) => {
  //               item?.workTimeThickThItems[materialTypeItem?.id]?.map((thickItem, index) => {
  //                 if (
  //                   document.getElementById(typeKey + 'type' + item.no + 'cls' + materialTypeItem?.id + 'input' + index)
  //                 ) {
  //                   document.getElementById(
  //                     typeKey + 'type' + item.no + 'cls' + materialTypeItem?.id + 'input' + index
  //                   ).style.backgroundColor = 'rgb(201 132 132 / 0%)';
  //                 }
  //                 if (Number(thickItem.value) !== Number(sameVal)) {
  //                   detailDisplay = true;
  //                   return;
  //                 }
  //               });
  //             });
  //           }
  //           if (!detailDisplay) {
  //             // IQX_WEBEST-296 簡易入力と詳細入力を切り替える際には値を引き継げるようにしてほしい
  //             if (item?.workTimeThickThItems) {
  //               usedItems?.map((materialTypeItem) => {
  //                 item?.workTimeThickThItems[materialTypeItem?.id]?.map((thickItem, index) => {
  //                   thickItem.value = item?.value;
  //                 });
  //               });
  //             }
  //           }
  //         });
  //       });
  //   }
  //   // サイズ簡易入力リスト
  //   setKaniListData(workTimeSizeThItems); // IQX_WEBEST-296 入力値が保持されるように修正
  //   detailDisplay = false;
  //   // 加工種類 / mmチェック
  //   let workTimeSizeHoleThItems = props?.detailsData?.workTimeSizeHoleThItems;
  //   if (workTimeSizeHoleThItems) {
  //     const usedItems = zaishitsuData?.filter((item) => item.info.isUsed);
  //     Object.keys(workTimeSizeHoleThItems)
  //       .filter(([sizeDataKey]) => getProcessDetailTypeName(parseInt(sizeDataKey), processMstRecord) !== undefined)
  //       ?.map(([typeKey, item], rowIndex) => {
  //         workTimeSizeHoleThItems[typeKey]?.map((item, workTimeSizeIndex) => {
  //           // サイズ
  //           if (item?.workTimeThickThItems) {
  //             let sameVal = item?.workTimeThickThItems[usedItems?.[0]?.id]?.[0]?.value;
  //             usedItems?.map((materialTypeItem) => {
  //               item?.workTimeThickThItems[materialTypeItem?.id]?.map((thickItem, index) => {
  //                 if (
  //                   document.getElementById(
  //                     'mm' + typeKey + 'type' + item.no + 'cls' + materialTypeItem?.id + 'input' + index
  //                   )
  //                 ) {
  //                   document.getElementById(
  //                     'mm' + typeKey + 'type' + item.no + 'cls' + materialTypeItem?.id + 'input' + index
  //                   ).style.backgroundColor = 'rgb(201 132 132 / 0%)';
  //                 }
  //                 if (Number(thickItem.value) !== Number(sameVal)) {
  //                   detailDisplay = true;
  //                   return;
  //                 }
  //               });
  //             });
  //           }
  //           if (!detailDisplay) {
  //             // IQX_WEBEST-296 簡易入力と詳細入力を切り替える際には値を引き継げるようにしてほしい
  //             if (item?.workTimeThickThItems) {
  //               usedItems?.map((materialTypeItem) => {
  //                 item?.workTimeThickThItems[materialTypeItem?.id]?.map((thickItem, index) => {
  //                   thickItem.value = item?.value;
  //                 });
  //               });
  //             }
  //           }
  //         });
  //       });
  //   }
  //   // mm簡易入力リスト
  //   setKaniAnaListData(workTimeSizeHoleThItems); // IQX_WEBEST-296 入力値が保持されるように修正
  // }, [props.editMode]);

  // const isDetailDisplay = (workTimeSizeThItems, workTimeSizeHoleThItems) => {
  //   let isDetail = false;
  //   // 加工種類 / サイズチェック
  //   if (workTimeSizeThItems) {
  //     const usedItems = props?.materialTypes?.filter((item) => item.info.isUsed);
  //     Object.keys(workTimeSizeThItems)
  //       .filter(
  //         ([sizeDataKey]) => getProcessDetailTypeName(parseInt(sizeDataKey), props?.processMstRecord) !== undefined
  //       )
  //       ?.map(([typeKey, item], rowIndex) => {
  //         workTimeSizeThItems[typeKey]?.map((item, workTimeSizeIndex) => {
  //           // サイズ
  //           if (item?.workTimeThickThItems) {
  //             let sameVal = item?.workTimeThickThItems[usedItems?.[0]?.id]?.[0]?.value;
  //             usedItems?.map((materialTypeItem) => {
  //               item?.workTimeThickThItems[materialTypeItem?.id]?.map((thickItem, index) => {
  //                 if (
  //                   document.getElementById(typeKey + 'type' + item.no + 'cls' + materialTypeItem?.id + 'input' + index)
  //                 ) {
  //                   document.getElementById(
  //                     typeKey + 'type' + item.no + 'cls' + materialTypeItem?.id + 'input' + index
  //                   ).style.backgroundColor = 'rgb(201 132 132 / 0%)';
  //                 }
  //                 if (Number(thickItem.value) !== Number(sameVal)) {
  //                   isDetail = true;
  //                   return;
  //                 }
  //               });
  //             });
  //           }
  //         });
  //       });
  //   }
  //   // 加工種類 / mmチェック
  //   if (workTimeSizeHoleThItems) {
  //     const usedItems = props?.materialTypes?.filter((item) => item.info.isUsed);
  //     Object.keys(workTimeSizeHoleThItems)
  //       .filter(
  //         ([sizeDataKey]) => getProcessDetailTypeName(parseInt(sizeDataKey), props?.processMstRecord) !== undefined
  //       )
  //       ?.map(([typeKey, item], rowIndex) => {
  //         workTimeSizeHoleThItems[typeKey]?.map((item, workTimeSizeIndex) => {
  //           // mm
  //           if (item?.workTimeThickThItems) {
  //             let sameVal = item?.workTimeThickThItems[usedItems?.[0]?.id]?.[0]?.value;
  //             usedItems?.map((materialTypeItem) => {
  //               item?.workTimeThickThItems[materialTypeItem?.id]?.map((thickItem, index) => {
  //                 if (
  //                   document.getElementById(
  //                     'mm' + typeKey + 'type' + item.no + 'cls' + materialTypeItem?.id + 'input' + index
  //                   )
  //                 ) {
  //                   document.getElementById(
  //                     'mm' + typeKey + 'type' + item.no + 'cls' + materialTypeItem?.id + 'input' + index
  //                   ).style.backgroundColor = 'rgb(201 132 132 / 0%)';
  //                 }
  //                 if (Number(thickItem.value) !== Number(sameVal)) {
  //                   isDetail = true;
  //                   return;
  //                 }
  //               });
  //             });
  //           }
  //         });
  //       });
  //   }
  //   if (isDetail) {
  //     setMode('details');
  //   } else {
  //     setMode('simple');
  //   }
  // };

  const addLength = () => {
    setIsLength(true);
  };

  // サイズ板厚ボタン押下
  const sizeThickness = () => {
    setErrIndexVal([]);
    setErrorMessage('');
    setIsSizeItaatsu(true);
  };

  // mm板厚ボタン押下
  const mmThickness = async () => {
    setErrIndexVal([]);
    setErrorMessage('');
    setIsMmItaatsu(true);
  };

  // サイズボタン押下
  const size = () => {
    setErrIndexVal([]);
    setErrorMessage('');
    setIsSize(true);
  };

  // mmボタン押下
  const anaSize = async (isMultiProcAnaSize = false) => {
    setErrIndexVal([]);
    setErrorMessage('');
    if (isMultiProcAnaSize) {
      setIsMultiProcAnaSize(true);
    } else {
      setIsAnaSize(true);
    }
  };

  const addLengthModalTitle = (
    <div
      style={{
        width: 400,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>
        cm<sup>2</sup>
      </p>
    </div>
  );

  const addSizeModalTitle = (
    <div
      style={{
        width: 400,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>サイズ</p>
    </div>
  );

  const addAnaSizeModalTitle = (
    <div
      style={{
        width: 400,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>mm</p>
    </div>
  );

  const addThicknessModalTitle = (
    <div
      style={{
        width: 400,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>板厚</p>
    </div>
  );

  const closeAddModal = () => {
    if (isLength === true) {
      setIsLength(false);
    } else if (isSize === true) {
      setIsSize(false);
    } else if (isSizeItaatsu === true) {
      setIsSizeItaatsu(false);
    } else if (isMmItaatsu === true) {
      setIsMmItaatsu(false);
    } else if (isAnaSize === true) {
      setIsAnaSize(false);
    }
  };

  const handleAreaChange = (event, id, field, isCheckZenkaku = true) => {
    if (regexExp.test(event.target.value) && !isDigitZenkaku(event.target.value)) return;
    if (isCheckZenkaku && regexExp.test(event.target.value)) {
      // 全角の場合、
      event.target.value = toHalfWidth(event.target.value); // 半角へ変換
      if (!isDigit(event.target.value)) event.target.value = 0;
    }
    const updatedData = detailsAreaTemp?.map((row) => {
      if (row.no === id) {
        return { ...row, [field]: event.target.value };
      }
      return row;
    });
    setDetailsAreaTemp(updatedData);
  };

  const addAreaRow = (id) => {
    const copyData = detailsAreaTemp.slice(); // Create a copy of the original array

    const insertIndex = detailsAreaTemp?.findIndex((item) => item.no === id); // Find the index of the item with id 2

    if (insertIndex !== -1) {
      const data = {
        no: detailsAreaTemp?.length + 1,
        value: 0,
        isOutOfRange: false,
      };
      copyData.splice(insertIndex + 1, 0, data); // Insert the new object after the found index
      setDetailsAreaTemp(copyData);
    }
  };

  const deleteArea = (id, e) => {
    if (detailsAreaTemp?.filter((item) => item.isOutOfRange === false)?.length > 2) {
      const updatedData = detailsAreaTemp?.map((row) => {
        if (row.no === id) {
          return { ...row, isOutOfRange: true };
        }
        return row;
      });
      setDetailsAreaTemp(updatedData);
    }
  };

  const addAreaMaster = () => {
    const deletedId = [];

    areaData?.forEach((item1, index) => {
      const found = detailsAreaTemp?.find((item2) => item2.no === item1.no && item2.isOutOfRange === true);
      if (found) {
        deletedId.push(item1.no);
      }
    });

    const newId = detailsAreaTemp
      ?.filter((item) => !item.isOutOfRange && !areaData.some((data2Item) => data2Item.no === item.no))
      ?.map((item) => item.no);

    let sortedList = [];
    if (category === WorkType.PaSurface || category === WorkType.SmSurface) {
      const updatedData = updateList(detailsList, deletedId, newId);
      sortedList = sortListByMasterData(updatedData, detailsAreaTemp);
    } else {
      const deleteData = deleteListColData(detailsList, deletedId);
      // const deleteCorrectionTimeFactorList = deleteListColData(correctionTimeFactorList, deletedId);

      const updatedData = updateListColData(deleteData, newId);
      // const updatecorrectionTimeFactorListData = updateListColData(deleteCorrectionTimeFactorList, newId);

      sortedList = sortListData(updatedData, detailsAreaTemp);
      // const sortedCorrectionTimeFactorList = sortSizeListData(updatecorrectionTimeFactorListData, detailsAreaTemp);
    }

    setIsLength(false);
    setAreaData(detailsAreaTemp);
    props.updatedArea(detailsAreaTemp);
    setDetailsList(sortedList);
    props.updatedIQ3KakouJikanList(sortedList);

    // setCorrectionTimeFactorList(sortedCorrectionTimeFactorList);
    // props.updatedcorrectionTimeFactorListData(sortedCorrectionTimeFactorList);
  };

  const cancelMasterData = () => {
    if (isLength === true) {
      setDetailsAreaTemp(areaData);
      setIsLength(false);
    } else if (isSize === true) {
      setIsSize(false);
      setSizeDataTemp(sizeData);
    } else if (isSizeItaatsu === true) {
      setIsSizeItaatsu(false);
      setSizeItaatsuTemp(sizeItaatsu);
    } else if (isMmItaatsu === true) {
      setIsMmItaatsu(false);
      setMmItaatsuTemp(mmItaatsu);
      setMmMultiProcHoleTemp(mmMultiProcHole);
    } else if (isAnaSize === true) {
      setAnaSizeDataTemp(anaSizeData);
      setIsAnaSize(false);
    } else if (isMultiProcAnaSize === true) {
      setAnaSizeMultiProcDataTemp(anaSizeMultiProcData);
      setIsMultiProcAnaSize(false);
    }
  };

  const addData = () => {};
  const isValueOrderCorrect = (e, no, field, tblName) => {
    let temp = [];
    if (tblName === 'anasize') {
      temp = anaSizeDataTemp?.filter((i) => i.isOutOfRange === false);
    } else if (tblName === 'size') {
      temp = sizeDataTemp?.filter((i) => i.isOutOfRange === false);
    } else if (tblName === 'sizeItaatsu') {
      temp = sizeItaatsuTemp?.filter((i) => i.isOutOfRange === false);
    } else if (tblName === 'mmItaatsu') {
      temp = mmItaatsuTemp?.filter((i) => i.isOutOfRange === false);
    } else if (tblName === 'multiProcAnasize') {
      temp = anaSizeMultiProcDataTemp?.filter((i) => i.isOutOfRange === false);
    } else if (tblName === 'mmMultiProc') {
      temp = mmMultiProcHoleTemp?.filter((i) => i.isOutOfRange === false);
    }

    const insertIndex = temp?.findIndex((item) => item.no === no);

    // IQX_WEBEST-220の対応-START
    if (regexExp.test(temp[insertIndex].value)) {
      // 全角の場合、
      temp[insertIndex].value = toHalfWidth(temp[insertIndex].value); // 半角へ変換
      e.target.value = temp[insertIndex].value;
      if (tblName === 'size') handleSizeChange(e, no, field);
      else if (tblName === 'anasize') handleAnaSizeChange(e, no, field);
      else if (tblName === 'sizeItaatsu') handleItaatsuChange(e, no, field);
      else if (tblName === 'mmItaatsu') handleItaatsuChange(e, no, field);
      else if (tblName === 'multiProcAnasize') handleAnaSizeChange(e, no, field);
      else if (tblName === 'mmMultiProc') handleItaatsuChange(e, no, field);
    }
    if (isNaN(parseFloat(temp[insertIndex].value))) {
      setErrIndexVal([...errIndexVal, insertIndex]);
      setErrorMessage('数字値を入力してください！');
      return;
    }
    // IQX_WEBEST-220の対応-END

    if (insertIndex > 0) {
      const prevValue = parseFloat(temp[insertIndex - 1].value);
      const currentValue = parseFloat(temp[insertIndex].value);
      const nextValue = parseFloat(temp[insertIndex + 1].value);
      if (currentValue > prevValue && currentValue < nextValue) {
        let temp = [insertIndex - 1, insertIndex, insertIndex + 1];

        setErrIndexVal(errIndexVal?.filter((item) => item !== insertIndex && item != insertIndex - 1));

        setErrorMessage('前のしきい値より大きい値を入力してください！');
      } else {
        setErrIndexVal([...errIndexVal, insertIndex]);

        if (currentValue <= prevValue) {
          setErrorMessage('前のしきい値より大きい値を入力してください！');
        } else if (currentValue >= nextValue) {
          setErrorMessage('次のしきい値より小さい値を入力してください！');
        }
      }
    } else {
      const currentValue = parseFloat(temp[insertIndex].value);
      const nextValue = parseFloat(temp[insertIndex + 1].value);

      if (currentValue < nextValue) {
        setErrIndexVal(errIndexVal?.filter((item) => item !== insertIndex));
      } else {
        setErrIndexVal([...errIndexVal, insertIndex]);
        setErrorMessage('次のしきい値より小さい値を入力してください！');
      }
    }
  };
  const addLengthContent = (
    <>
      <div style={{ height: 400, overflow: 'auto' }}>
        <Row className="chargeAmount registerModal">
          <Col style={{ width: '100%' }}>
            <Table className="master-table">
              <thead>
                <tr style={{ textAlign: 'center' }}>
                  <th style={{ width: '20%' }} className="param-tbl-header">
                    No
                  </th>

                  <th style={{ width: '60%' }} className="param-tbl-header">
                    <Space>
                      <label>しきい値</label>（≦）
                    </Space>
                  </th>
                </tr>
              </thead>
              <tbody>
                {detailsAreaTemp
                  ?.filter((subitem) => subitem.isOutOfRange === false)
                  ?.map((item, index) => (
                    <tr key={index} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <td>{index + 1}</td>

                      <td>
                        <Input
                          value={item.value}
                          onChange={(e) => handleAreaChange(e, item.no, 'value', false)}
                          onBlur={(e) => handleAreaChange(e, item.no, 'value')}
                          onPressEnter={(e) => handleAreaChange(e, item.no, 'value')}
                          style={{ pointerEvents: editMode ? 'auto' : 'none' }}
                        ></Input>
                      </td>
                      <td
                        style={{ border: 'none', backgroundColor: 'white', verticalAlign: 'middle', width: '20%' }}
                        className="min"
                      >
                        <Row justify="center">
                          <PlusCircleFilled
                            onClick={() => addAreaRow(item.no)}
                            className="add-remove-icon"
                            style={{ marginLeft: 5, marginRight: 5, pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                          <CloseCircleFilled
                            className="add-remove-icon"
                            onClick={(e) => deleteArea(item.no, e)}
                            style={{ pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                        </Row>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
      <Row justify="center" className="mt-2">
        <Button className={isEmpty(errIndexVal) ? 'mainButton' : 'disabledButton'} id="update" onClick={addAreaMaster}>
          OK
        </Button>
        <Button className="cancelButton" style={{ marginLeft: 10 }} onClick={cancelMasterData}>
          キャンセル
        </Button>
      </Row>
    </>
  );

  // サイズマスタの値を変更した場合、
  const handleSizeChange = (event, no, field) => {
    if (regexExp.test(event.target.value) && !isDigitZenkaku(event.target.value)) return;
    const updatedData = sizeDataTemp?.map((row) => {
      if (row.no === no) {
        return { ...row, [field]: event.target.value };
      }
      return row;
    });
    setSizeDataTemp(updatedData);
  };

  // mmマスタの値を変更した場合、
  const handleAnaSizeChange = (event, no, field, isMultiProcAnaSize = false) => {
    if (regexExp.test(event.target.value) && !isDigitZenkaku(event.target.value)) return;
    let updatedData = anaSizeDataTemp;
    if (isMultiProcAnaSize) {
      updatedData = anaSizeMultiProcDataTemp?.map((row) => {
        if (row.no === no) {
          return { ...row, [field]: event.target.value };
        }
        return row;
      });
      setAnaSizeMultiProcDataTemp(updatedData);
    } else {
      updatedData = anaSizeDataTemp?.map((row) => {
        if (row.no === no) {
          return { ...row, [field]: event.target.value };
        }
        return row;
      });
      setAnaSizeDataTemp(updatedData);
    }
  };

  // サイズマスタの行追加を押下
  const addSize = (no, index) => {
    inputRef.current[index].focus();
    const copyData = sizeDataTemp?.slice(); // Create a copy of the original array

    const insertIndex = sizeDataTemp?.findIndex((item) => item.no === no); // Find the index of the item with id 2

    if (insertIndex !== -1) {
      const data = {
        no: sizeDataTemp?.length + 1,
        value: 0,
        isOutOfRange: false,
      };
      copyData.splice(insertIndex + 1, 0, data); // Insert the new object after the found index
      setSizeDataTemp(copyData);
    }
  };

  // mmマスタの行追加を押下 成形型穴
  const addAnaSize = (no, index) => {
    inputRef.current[index].focus();
    const copyData = anaSizeDataTemp?.slice(); // Create a copy of the original array

    const insertIndex = anaSizeDataTemp?.findIndex((item) => item.no === no); // Find the index of the item with id 2

    if (insertIndex !== -1) {
      const data = {
        no: anaSizeDataTemp?.length + 1,
        value: 0,
        isOutOfRange: false,
      };
      copyData.splice(insertIndex + 1, 0, data); // Insert the new object after the found index
      setAnaSizeDataTemp(copyData);
    }
  };

  // mmマスタの行追加を押下 多工程穴
  const addMultiProcAnaSize = (no, index) => {
    inputRef.current[index].focus();
    const copyData = anaSizeMultiProcDataTemp?.slice(); // Create a copy of the original array

    const insertIndex = anaSizeMultiProcDataTemp?.findIndex((item) => item.no === no); // Find the index of the item with id 2

    if (insertIndex !== -1) {
      const data = {
        no: anaSizeMultiProcDataTemp?.length + 1,
        value: 0,
        isOutOfRange: false,
      };
      copyData.splice(insertIndex + 1, 0, data); // Insert the new object after the found index
      setAnaSizeMultiProcDataTemp(copyData);
    }
  };

  // サイズマスタの行削除を押下
  const deleteSize = (no, e, index) => {
    // 更新するエラーインデックスを得る
    const updatedErrorIndexes = errIndexVal?.filter((item) => item !== index);

    const finalErrorIndexes = updatedErrorIndexes?.map((item) => (item > index ? item - 1 : item));
    setErrIndexVal(finalErrorIndexes);
    if (sizeDataTemp?.filter((item) => !item.isOutOfRange)?.length > 2) {
      const updatedData = sizeDataTemp?.map((row) => {
        if (row.no === no) {
          return { ...row, isOutOfRange: true };
        }
        return row;
      });
      setSizeDataTemp(updatedData);
      const filterData = updatedData?.filter((i) => !i.isOutOfRange);
      if (index + 1 !== filterData?.length) {
        inputRef.current[index].focus();
      }
    }
  };

  // mmマスタの行削除を押下 成形型穴
  const deleteAnaSize = (no, e, index) => {
    // 更新するエラーインデックスを得る
    const updatedErrorIndexes = errIndexVal?.filter((item) => item !== index);

    const finalErrorIndexes = updatedErrorIndexes?.map((item) => (item > index ? item - 1 : item));
    setErrIndexVal(finalErrorIndexes);
    if (anaSizeDataTemp?.filter((item) => !item.isOutOfRange)?.length > 2) {
      const updatedData = anaSizeDataTemp?.map((row) => {
        if (row.no === no) {
          return { ...row, isOutOfRange: true };
        }
        return row;
      });
      setAnaSizeDataTemp(updatedData);
      const filterData = updatedData?.filter((i) => !i.isOutOfRange);
      if (index + 1 !== filterData?.length) {
        inputRef.current[index].focus();
      }
    }
  };

  // mmマスタの行削除を押下 多工程穴
  const deleteMultiProcAnaSize = (no, e, index) => {
    // 更新するエラーインデックスを得る
    const updatedErrorIndexes = errIndexVal?.filter((item) => item !== index);

    const finalErrorIndexes = updatedErrorIndexes?.map((item) => (item > index ? item - 1 : item));
    setErrIndexVal(finalErrorIndexes);
    if (anaSizeMultiProcDataTemp?.filter((item) => !item.isOutOfRange)?.length > 2) {
      const updatedData = anaSizeMultiProcDataTemp?.map((row) => {
        if (row.no === no) {
          return { ...row, isOutOfRange: true };
        }
        return row;
      });
      setAnaSizeMultiProcDataTemp(updatedData);
      const filterData = updatedData?.filter((i) => !i.isOutOfRange);
      if (index + 1 !== filterData?.length) {
        inputRef.current[index].focus();
      }
    }
  };

  // 板厚リストの詳細情報を削除する
  const deleteDetailListData = (data, deletedId) => {
    const updatedData = { ...data };

    Object.values(data)?.forEach((item) => {
      item?.forEach((subitem) => {
        Object.entries(subitem?.workTimeThickThItems)?.forEach(([listKey, listItem]) => {
          if (subitem?.workTimeThickThItems && listItem) {
            // listItem = deleteListColData(listItem, deletedId);
            subitem.workTimeThickThItems[listKey] = deleteListColData(listItem, deletedId);
          }
        });
      });
    });

    return data;
  };

  // 板厚リストの詳細情報を更新する
  const updateDetailListData = (deletedData, newId) => {
    // const updatedData = JSON.parse(JSON.stringify(deletedData)); // Create a deep copy of the data array

    // updatedData?.forEach((item) => {
    //   item.lstData?.forEach((i) => {
    //     i.list?.forEach((j) => {
    //       if (j.lstData) {
    //         newId?.forEach((key) => {
    //           // Add new objects to lstData
    //           j.lstData.push({
    //             key: key,
    //             value: '',
    //           });
    //         });
    //       }
    //     });
    //   });
    // });

    const updatedData = { ...deletedData };

    Object.values(updatedData)?.forEach((item) => {
      item?.forEach((subitem) => {
        Object.values(subitem?.workTimeThickThItems)?.forEach((listItem) => {
          if (listItem) {
            listItem = updateListColData(listItem, newId);
          }
        });
      });
    });

    return updatedData;
  };

  // 板厚リストの詳細情報を並び替え
  const sortDetailListData = (list, masterData) => {
    // const sortedList = JSON.parse(JSON.stringify(list));

    // sortedList?.forEach((item) => {
    //   item.lstData?.forEach((i) => {
    //     i.list?.forEach((j) => {
    //       if (j.lstData) {
    //         j.lstData.sort((a, b) => {
    //           const aIndex = masterData?.findIndex((obj) => obj.id === a.key);
    //           const bIndex = masterData?.findIndex((obj) => obj.id === b.key);
    //           return aIndex - bIndex;
    //         });
    //       }
    //     });
    //   });
    // });

    const sortedList = { ...list };

    Object.values(sortedList)?.forEach((item) => {
      item?.forEach((subitem) => {
        Object.values(subitem?.workTimeThickThItems)?.forEach((listItem) => {
          if (listItem) {
            listItem = sortListData(listItem, masterData);
          }
        });
      });
    });

    return sortedList;
  };

  // 詳細情報を作成する
  const createDetailListData = (zaishitsuMstData, itaatsuMstData) => {
    const filteredData2 = itaatsuMstData
      ?.filter((subitem) => !subitem.isOutOfRange)
      ?.map((item) => {
        return {
          no: item.no,
          value: 0,
          isOutOfRange: false,
        };
      });
    const result = {};
    zaishitsuMstData?.map((materialType) => {
      result[materialType.id] = filteredData2;
    });
    return { workTimeThickThItems: result };
  };

  // サイズマスタのOKボタン押下
  const okSizeMaster = () => {
    const deletedId = [];

    sizeData?.forEach((item1, index) => {
      const found = sizeDataTemp?.find((item2) => item2.no === item1.no && item2.isOutOfRange);
      if (found) {
        deletedId.push(item1.no);
      }
    });

    const newId = sizeDataTemp
      ?.filter((item) => !item.isOutOfRange && !sizeData?.some((data2Item) => data2Item.no === item.no))
      ?.map((item) => item.no);

    // const deletedData = deleteListData(kaniListData, deletedId);
    const detailsData = createDetailListData(zaishitsuData, sizeItaatsu);
    // const updatedData = updateListData(deletedData, newId, detailsData);

    // const sortedList = sortListData(updatedData, sizeDataTemp);

    const updatedData = updateList(kaniListData, deletedId, newId, detailsData);
    const sortedList = sortListByMasterData(updatedData, sizeDataTemp);

    setIsSize(false);
    setSizeData(sizeDataTemp);
    props.updatediq3SizeMaster(sizeDataTemp);

    setKaniListData(sortedList);
    props.updatediq3KaniListData(sortedList);
  };

  // mm成形型穴マスタのOKボタン押下(簡易入力・詳細入力)
  const okAnaSizeMaster = () => {
    const deletedId = [];

    anaSizeData?.forEach((item1, index) => {
      const found = anaSizeDataTemp?.find((item2) => item2.no === item1.no && item2.isOutOfRange);
      if (found) {
        deletedId.push(item1.no);
      }
    });

    const newId = anaSizeDataTemp
      ?.filter((item) => !item.isOutOfRange && !anaSizeData?.some((data2Item) => data2Item.no === item.no))
      ?.map((item) => item.no);

    // const deletedData = deleteListData(kaniAnaListData, deletedId);
    const detailsData = createDetailListData(zaishitsuData, mmItaatsu);
    // const updatedData = updateListData(deletedData, newId, detailsData);
    // const sortedList = sortListData(updatedData, anaSizeDataTemp);

    const updatedData = updateList(kaniAnaListData, deletedId, newId, detailsData);
    const sortedList = sortListByMasterData(updatedData, anaSizeDataTemp);

    setIsAnaSize(false);
    setAnaSizeData(anaSizeDataTemp);
    props.updateSizeMmMaster(anaSizeDataTemp);

    setKaniAnaListData(sortedList);
    props.updateiq3KaniAnaListData(sortedList);
  };

  // mm多工程穴マスタのOKボタン押下(簡易入力・詳細入力)
  const okMultiProcAnaSizeMaster = () => {
    const deletedId = [];

    anaSizeMultiProcData?.forEach((item1, index) => {
      const found = anaSizeMultiProcDataTemp?.find((item2) => item2.no === item1.no && item2.isOutOfRange);
      if (found) {
        deletedId.push(item1.no);
      }
    });

    const newId = anaSizeMultiProcDataTemp
      ?.filter((item) => !item.isOutOfRange && !anaSizeMultiProcData?.some((data2Item) => data2Item.no === item.no))
      ?.map((item) => item.no);

    // const deletedData = deleteListData(kaniAnaListData, deletedId);
    const detailsData = createDetailListData(zaishitsuData, mmItaatsu);
    // const updatedData = updateListData(deletedData, newId, detailsData);
    // const sortedList = sortListData(updatedData, anaSizeDataTemp);

    const updatedData = updateList(kaniMultiProcAnaListData, deletedId, newId, detailsData);
    const sortedList = sortListByMasterData(updatedData, anaSizeMultiProcDataTemp);

    setIsAnaSize(false);
    setAnaSizeMultiProcData(anaSizeMultiProcDataTemp);
    props.updateSizeMmMultiProcHoleMaster(anaSizeMultiProcDataTemp);

    setKaniMultiProcAnaListData(sortedList);
    props.updateiq3KaniMultiProcAnaListData(sortedList);
    setIsMultiProcAnaSize(false);
  };

  // サイズマスタ
  const addSizeContent = (
    <>
      <div style={{ height: 400, overflow: 'auto' }}>
        <Row className="chargeAmount registerModal">
          <Col style={{ width: '100%' }}>
            <Table className="master-table">
              <thead>
                <tr style={{ textAlign: 'center' }}>
                  <th style={{ width: '20%' }} className="param-tbl-header">
                    No
                  </th>

                  <th style={{ width: '60%' }} className="param-tbl-header">
                    <Space>
                      <label>しきい値</label>（≦）
                    </Space>
                  </th>
                </tr>
              </thead>
              <tbody>
                {sizeDataTemp
                  ?.filter((subitem) => !subitem.isOutOfRange)
                  ?.map((item, index) => (
                    <tr key={index} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <td>{index + 1}</td>

                      <td>
                        {errIndexVal?.includes(index) ? (
                          <Popover
                            content={<div style={{ padding: 7 }}>{errorMessage}</div>}
                            placement="left"
                            visible={true}
                          ></Popover>
                        ) : (
                          ''
                        )}
                        <Input
                          value={item.value}
                          onChange={(e) => handleSizeChange(e, item.no, 'value')}
                          onBlur={(e) => isValueOrderCorrect(e, item.no, 'value', 'size')}
                          onPressEnter={(e) => isValueOrderCorrect(e, item.no, 'value', 'size')}
                          className={errIndexVal?.includes(index) ? 'red-border' : ''}
                          style={{
                            ...getInputBorderStyle(index, sizeDataTemp),
                            pointerEvents: editMode ? 'auto' : 'none',
                          }}
                          ref={(ref) => (inputRef.current[index] = ref)}
                          onKeyPress={(e) => {
                            handleKeyPress(e, false);
                          }}
                        ></Input>
                      </td>
                      <td
                        style={{ border: 'none', backgroundColor: 'white', verticalAlign: 'middle', width: '20%' }}
                        className="min"
                      >
                        <Row justify="center">
                          <PlusCircleFilled
                            onClick={() => addSize(item.no, index + 1)}
                            className="add-remove-icon"
                            style={{ marginLeft: 5, marginRight: 5, pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                          <CloseCircleFilled
                            className="add-remove-icon"
                            onClick={(e) => deleteSize(item.no, e, index)}
                            style={{ pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                        </Row>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
      <Row justify="center" className="mt-2">
        <Button className={isEmpty(errIndexVal) ? 'mainButton' : 'disabledButton'} id="update" onClick={okSizeMaster}>
          OK
        </Button>
        <Button className="cancelButton" style={{ marginLeft: 10 }} id="discard" onClick={cancelMasterData}>
          キャンセル
        </Button>
      </Row>
    </>
  );

  // mmマスタ　成形型穴
  const addAnaSizeContent = (
    <>
      <div style={{ height: 400, overflow: 'auto' }}>
        <Row className="chargeAmount registerModal">
          <Col style={{ width: '100%' }}>
            <Table className="master-table">
              <thead>
                <tr style={{ textAlign: 'center' }}>
                  <th style={{ width: '20%' }} className="param-tbl-header">
                    No
                  </th>

                  <th style={{ width: '60%' }} className="param-tbl-header">
                    <Space>
                      <label>しきい値</label>（≦）
                    </Space>
                  </th>
                </tr>
              </thead>
              <tbody>
                {anaSizeDataTemp
                  ?.filter((subitem) => !subitem.isOutOfRange)
                  ?.map((item, index) => (
                    <tr key={index} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <td>{index + 1}</td>

                      <td>
                        {errIndexVal?.includes(index) ? (
                          <Popover
                            content={<div style={{ padding: 7 }}>{errorMessage}</div>}
                            placement="left"
                            visible={true}
                          ></Popover>
                        ) : (
                          ''
                        )}
                        <Input
                          value={item.value}
                          onChange={(e) => handleAnaSizeChange(e, item.no, 'value')}
                          onBlur={(e) => isValueOrderCorrect(e, item.no, 'value', 'anasize')}
                          onPressEnter={(e) => isValueOrderCorrect(e, item.no, 'value', 'anasize')}
                          className={errIndexVal?.includes(index) ? 'red-border' : ''}
                          style={{
                            ...getInputBorderStyle(index, anaSizeDataTemp),
                            pointerEvents: editMode ? 'auto' : 'none',
                          }}
                          ref={(ref) => (inputRef.current[index] = ref)}
                          onKeyPress={(e) => {
                            handleKeyPress(e, false);
                          }}
                        ></Input>
                      </td>
                      <td
                        style={{ border: 'none', backgroundColor: 'white', verticalAlign: 'middle', width: '20%' }}
                        className="min"
                      >
                        <Row justify="center">
                          <PlusCircleFilled
                            onClick={() => addAnaSize(item.no, index + 1)}
                            className="add-remove-icon"
                            style={{ marginLeft: 5, marginRight: 5, pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                          <CloseCircleFilled
                            className="add-remove-icon"
                            onClick={(e) => deleteAnaSize(item.no, e, index)}
                            style={{ pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                        </Row>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
      <Row justify="center" className="mt-2">
        <Button
          className={isEmpty(errIndexVal) ? 'mainButton' : 'disabledButton'}
          id="update"
          onClick={okAnaSizeMaster}
        >
          OK
        </Button>
        <Button className="cancelButton" style={{ marginLeft: 10 }} id="discard" onClick={cancelMasterData}>
          キャンセル
        </Button>
      </Row>
    </>
  );

  // mmマスタ　多工程穴
  const addMultiProcAnaSizeContent = (
    <>
      <div style={{ height: 400, overflow: 'auto' }}>
        <Row className="chargeAmount registerModal">
          <Col style={{ width: '100%' }}>
            <Table className="master-table">
              <thead>
                <tr style={{ textAlign: 'center' }}>
                  <th style={{ width: '20%' }} className="param-tbl-header">
                    No
                  </th>

                  <th style={{ width: '60%' }} className="param-tbl-header">
                    <Space>
                      <label>しきい値</label>（≦）
                    </Space>
                  </th>
                </tr>
              </thead>
              <tbody>
                {anaSizeMultiProcDataTemp
                  ?.filter((subitem) => !subitem.isOutOfRange)
                  ?.map((item, index) => (
                    <tr key={index} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <td>{index + 1}</td>

                      <td>
                        {errIndexVal?.includes(index) ? (
                          <Popover
                            content={<div style={{ padding: 7 }}>{errorMessage}</div>}
                            placement="left"
                            visible={true}
                          ></Popover>
                        ) : (
                          ''
                        )}
                        <Input
                          value={item.value}
                          onChange={(e) => handleAnaSizeChange(e, item.no, 'value', true)}
                          onBlur={(e) => isValueOrderCorrect(e, item.no, 'value', 'multiProcAnasize')}
                          onPressEnter={(e) => isValueOrderCorrect(e, item.no, 'value', 'multiProcAnasize')}
                          className={errIndexVal?.includes(index) ? 'red-border' : ''}
                          style={{
                            ...getInputBorderStyle(index, anaSizeMultiProcDataTemp),
                            pointerEvents: editMode ? 'auto' : 'none',
                          }}
                          ref={(ref) => (inputRef.current[index] = ref)}
                          onKeyPress={(e) => {
                            handleKeyPress(e, false);
                          }}
                        ></Input>
                      </td>
                      <td
                        style={{ border: 'none', backgroundColor: 'white', verticalAlign: 'middle', width: '20%' }}
                        className="min"
                      >
                        <Row justify="center">
                          <PlusCircleFilled
                            onClick={() => addMultiProcAnaSize(item.no, index + 1)}
                            className="add-remove-icon"
                            style={{ marginLeft: 5, marginRight: 5, pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                          <CloseCircleFilled
                            className="add-remove-icon"
                            onClick={(e) => deleteMultiProcAnaSize(item.no, e, index)}
                            style={{ pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                        </Row>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
      <Row justify="center" className="mt-2">
        <Button
          className={isEmpty(errIndexVal) ? 'mainButton' : 'disabledButton'}
          id="update"
          onClick={okMultiProcAnaSizeMaster}
        >
          OK
        </Button>
        <Button className="cancelButton" style={{ marginLeft: 10 }} id="discard" onClick={cancelMasterData}>
          キャンセル
        </Button>
      </Row>
    </>
  );

  // 板厚マスタの値を変更した場合、
  const handleItaatsuChange = (event, no, field) => {
    if (regexExp.test(event.target.value) && !isDigitZenkaku(event.target.value)) return;
    let temp = isSizeItaatsu ? sizeItaatsuTemp : isMultiProcAnaSize ? mmMultiProcHole : mmItaatsuTemp;
    const updatedData = temp?.map((row) => {
      if (row.no === no) {
        return { ...row, [field]: event.target.value };
      }
      return row;
    });
    isSizeItaatsu
      ? setSizeItaatsuTemp(updatedData)
      : isMultiProcAnaSize
      ? setMmMultiProcHoleTemp(updatedData)
      : setMmItaatsuTemp(updatedData);
  };

  // 板厚マスタの行追加を押下
  const addItaatsu = (no, index) => {
    inputRef.current[index].focus();
    let temp = isSizeItaatsu ? sizeItaatsuTemp : isMultiProcAnaSize ? mmMultiProcHoleTemp : mmItaatsuTemp;
    const copyData = temp?.slice(); // Create a copy of the original array

    const insertIndex = temp?.findIndex((item) => item.no === no); // Find the index of the item with id 2

    if (insertIndex !== -1) {
      const data = {
        no: temp?.length + 1,
        value: 0,
        isOutOfRange: false,
      };
      copyData.splice(insertIndex + 1, 0, data); // Insert the new object after the found index
      isSizeItaatsu
        ? setSizeItaatsuTemp(copyData)
        : isMultiProcAnaSize
        ? setMmMultiProcHoleTemp(copyData)
        : setMmItaatsuTemp(copyData);
    }
  };

  // 板厚マスタの行削除を押下
  const deleteItaatsu = (no, e, index) => {
    // 更新するエラーインデックスを得る
    const updatedErrorIndexes = errIndexVal?.filter((item) => item !== index);

    const finalErrorIndexes = updatedErrorIndexes?.map((item) => (item > index ? item - 1 : item));
    setErrIndexVal(finalErrorIndexes);

    let temp = isSizeItaatsu ? sizeItaatsuTemp : isMultiProcAnaSize ? mmMultiProcHoleTemp : mmItaatsuTemp;
    if (temp?.filter((item) => !item.isOutOfRange)?.length > 2) {
      const updatedData = temp?.map((row) => {
        if (row.no === no) {
          return { ...row, isOutOfRange: true };
        }
        return row;
      });
      isSizeItaatsu
        ? setSizeItaatsuTemp(updatedData)
        : isMultiProcAnaSize
        ? setMmMultiProcHoleTemp(updatedData)
        : setMmItaatsuTemp(updatedData);
      const filterData = updatedData?.filter((i) => !i.isOutOfRange);
      if (index + 1 !== filterData?.length) {
        inputRef.current[index].focus();
      }
    }
  };

  // 板厚マスタのOKボタン押下
  const okItaatsuMaster = async (isMultiProcHole = false) => {
    setBtnEnable(false);
    const deletedId = [];

    if (isSizeItaatsu) {
      sizeItaatsu?.forEach((item1, index) => {
        const found = sizeItaatsuTemp?.find((item2) => item2.no === item1.no && item2.isOutOfRange);
        if (found) {
          deletedId.push(item1.no);
        }
      });

      const newId = sizeItaatsuTemp
        ?.filter((item) => !item.isOutOfRange && !sizeItaatsu?.some((data2Item) => data2Item.no === item.no))
        ?.map((item) => item.no);

      const deletedKaniData = deleteDetailListData(kaniListData, deletedId);

      const updatedKaniData = updateDetailListData(deletedKaniData, newId);

      const sortedKaniList = sortDetailListData(updatedKaniData, sizeItaatsuTemp);

      setIsSizeItaatsu(false);
      setSizeItaatsu(sizeItaatsuTemp);
      props.updatedSizeItaatsu(sizeItaatsuTemp);

      setKaniListData(sortedKaniList);
      props.updatediq3KaniListData(sortedKaniList);
    } else {
      if (isMultiProcHole) {
        mmMultiProcHole?.forEach((item1, index) => {
          const found = mmMultiProcHoleTemp?.find((item2) => item2.no === item1.no && item2.isOutOfRange);
          if (found) {
            deletedId.push(item1.no);
          }
        });

        const newId = mmMultiProcHoleTemp
          ?.filter((item) => !item.isOutOfRange && !mmItaatsu?.some((data2Item) => data2Item.no === item.no))
          ?.map((item) => item.no);

        const deletedAnaData = deleteDetailListData(kaniMultiProcAnaListData, deletedId);

        const updatedAnaData = updateDetailListData(deletedAnaData, newId);

        const sortedAnaList = sortDetailListData(updatedAnaData, mmMultiProcHoleTemp);

        setIsMmItaatsu(false);
        setIsMultiProcAnaSize(false);
        setMmMultiProcHoleTemp(mmMultiProcHoleTemp);
        props.updateMmMultiProcHole(mmMultiProcHoleTemp);
        setKaniMultiProcAnaListData(sortedAnaList);
        props.updateiq3KaniMultiProcAnaListData(sortedAnaList);
      } else {
        mmItaatsu?.forEach((item1, index) => {
          const found = mmItaatsuTemp?.find((item2) => item2.no === item1.no && item2.isOutOfRange);
          if (found) {
            deletedId.push(item1.no);
          }
        });

        const newId = mmItaatsuTemp
          ?.filter((item) => !item.isOutOfRange && !mmItaatsu?.some((data2Item) => data2Item.no === item.no))
          ?.map((item) => item.no);

        const deletedAnaData = deleteDetailListData(kaniAnaListData, deletedId);

        const updatedAnaData = updateDetailListData(deletedAnaData, newId);

        const sortedAnaList = sortDetailListData(updatedAnaData, mmItaatsuTemp);

        setIsMmItaatsu(false);
        setMmItaatsu(mmItaatsuTemp);
        props.updatedMmItaatsu(mmItaatsuTemp);
        setKaniAnaListData(sortedAnaList);
        props.updateiq3KaniAnaListData(sortedAnaList);
      }
    }
  };

  // サイズ板厚マスタ
  const addSizeItaatsuContent = (
    <>
      <div style={{ height: 400, overflow: 'auto' }}>
        <Row className="chargeAmount registerModal">
          <Col style={{ width: '100%' }}>
            <Table className="master-table">
              <thead>
                <tr style={{ textAlign: 'center' }}>
                  <th style={{ width: '20%' }} className="param-tbl-header">
                    No
                  </th>

                  <th style={{ width: '60%' }} className="param-tbl-header">
                    <Space>
                      <label>しきい値</label>（≦）
                    </Space>
                  </th>
                </tr>
              </thead>
              <tbody>
                {sizeItaatsuTemp
                  ?.filter((subitem) => !subitem.isOutOfRange)
                  ?.map((item, index) => (
                    <tr key={index} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <td>{index + 1}</td>

                      <td>
                        {errIndexVal?.includes(index) ? (
                          <Popover
                            content={<div style={{ padding: 7 }}>{errorMessage}</div>}
                            placement="left"
                            visible={true}
                          ></Popover>
                        ) : (
                          ''
                        )}
                        <Input
                          value={item.value}
                          onChange={(e) => handleItaatsuChange(e, item.no, 'value')}
                          onBlur={(e) => isValueOrderCorrect(e, item.no, 'value', 'sizeItaatsu')}
                          onPressEnter={(e) => isValueOrderCorrect(e, item.no, 'value', 'sizeItaatsu')}
                          className={errIndexVal?.includes(index) ? 'red-border' : ''}
                          style={{
                            ...getInputBorderStyle(index, sizeItaatsuTemp),
                            pointerEvents: editMode ? 'auto' : 'none',
                          }}
                          onKeyPress={(e) => {
                            handleKeyPress(e, false);
                          }}
                          ref={(ref) => (inputRef.current[index] = ref)}
                        ></Input>
                      </td>
                      <td
                        style={{ border: 'none', backgroundColor: 'white', verticalAlign: 'middle', width: '20%' }}
                        className="min"
                      >
                        <Row justify="center">
                          <PlusCircleFilled
                            onClick={() => addItaatsu(item.no, index + 1)}
                            className="add-remove-icon"
                            style={{ marginLeft: 5, marginRight: 5, pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                          <CloseCircleFilled
                            className="add-remove-icon"
                            onClick={(e) => deleteItaatsu(item.no, e, index)}
                            style={{ pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                        </Row>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
      <Row justify="center" className="mt-2">
        <Button
          className={isEmpty(errIndexVal) ? 'mainButton' : 'disabledButton'}
          id="update"
          onClick={(e) => okItaatsuMaster()}
        >
          OK
        </Button>
        <Button className="cancelButton" style={{ marginLeft: 10 }} id="discard" onClick={cancelMasterData}>
          キャンセル
        </Button>
      </Row>
    </>
  );

  // mm板厚マスタ (成形型穴)
  const addMmItaatsuContent = (
    <>
      <div style={{ height: 400, overflow: 'auto' }}>
        <Row className="chargeAmount registerModal">
          <Col style={{ width: '100%' }}>
            <Table className="master-table">
              <thead>
                <tr style={{ textAlign: 'center' }}>
                  <th style={{ width: '20%' }} className="param-tbl-header">
                    No
                  </th>

                  <th style={{ width: '60%' }} className="param-tbl-header">
                    <Space>
                      <label>しきい値</label>（≦）
                    </Space>
                  </th>
                </tr>
              </thead>
              <tbody>
                {mmItaatsuTemp
                  ?.filter((subitem) => !subitem.isOutOfRange)
                  ?.map((item, index) => (
                    <tr key={index} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <td>{index + 1}</td>

                      <td>
                        {errIndexVal?.includes(index) ? (
                          <Popover
                            content={<div style={{ padding: 7 }}>{errorMessage}</div>}
                            placement="left"
                            visible={true}
                          ></Popover>
                        ) : (
                          ''
                        )}
                        <Input
                          value={item.value}
                          onChange={(e) => handleItaatsuChange(e, item.no, 'value')}
                          onBlur={(e) => isValueOrderCorrect(e, item.no, 'value', 'mmItaatsu')}
                          onPressEnter={(e) => isValueOrderCorrect(e, item.no, 'value', 'mmItaatsu')}
                          className={errIndexVal?.includes(index) ? 'red-border' : ''}
                          style={{
                            ...getInputBorderStyle(index, mmItaatsuTemp),
                            pointerEvents: editMode ? 'auto' : 'none',
                          }}
                          onKeyPress={(e) => {
                            handleKeyPress(e, false);
                          }}
                          ref={(ref) => (inputRef.current[index] = ref)}
                        ></Input>
                      </td>
                      <td
                        style={{ border: 'none', backgroundColor: 'white', verticalAlign: 'middle', width: '20%' }}
                        className="min"
                      >
                        <Row justify="center">
                          <PlusCircleFilled
                            onClick={() => addItaatsu(item.no, index + 1)}
                            className="add-remove-icon"
                            style={{ marginLeft: 5, marginRight: 5, pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                          <CloseCircleFilled
                            className="add-remove-icon"
                            onClick={(e) => deleteItaatsu(item.no, e, index)}
                            style={{ pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                        </Row>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
      <Row justify="center" className="mt-2">
        <Button
          className={isEmpty(errIndexVal) ? 'mainButton' : 'disabledButton'}
          id="update"
          onClick={(e) => okItaatsuMaster()}
        >
          OK
        </Button>
        <Button className="cancelButton" style={{ marginLeft: 10 }} id="discard" onClick={cancelMasterData}>
          キャンセル
        </Button>
      </Row>
    </>
  );

  // mm板厚マスタ (多工程穴)
  const addMmMultiProcContent = (
    <>
      <div style={{ height: 400, overflow: 'auto' }}>
        <Row className="chargeAmount registerModal">
          <Col style={{ width: '100%' }}>
            <Table className="master-table">
              <thead>
                <tr style={{ textAlign: 'center' }}>
                  <th style={{ width: '20%' }} className="param-tbl-header">
                    No
                  </th>

                  <th style={{ width: '60%' }} className="param-tbl-header">
                    <Space>
                      <label>しきい値</label>（≦）
                    </Space>
                  </th>
                </tr>
              </thead>
              <tbody>
                {mmMultiProcHoleTemp
                  ?.filter((subitem) => !subitem.isOutOfRange)
                  ?.map((item, index) => (
                    <tr key={index} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      <td>{index + 1}</td>

                      <td>
                        {errIndexVal?.includes(index) ? (
                          <Popover
                            content={<div style={{ padding: 7 }}>{errorMessage}</div>}
                            placement="left"
                            visible={true}
                          ></Popover>
                        ) : (
                          ''
                        )}
                        <Input
                          value={item.value}
                          onChange={(e) => handleItaatsuChange(e, item.no, 'value')}
                          onBlur={(e) => isValueOrderCorrect(e, item.no, 'value', 'mmMultiProc')}
                          onPressEnter={(e) => isValueOrderCorrect(e, item.no, 'value', 'mmMultiProc')}
                          className={errIndexVal?.includes(index) ? 'red-border' : ''}
                          style={{
                            ...getInputBorderStyle(index, mmMultiProcHoleTemp),
                            pointerEvents: editMode ? 'auto' : 'none',
                          }}
                          onKeyPress={(e) => {
                            handleKeyPress(e, false);
                          }}
                          ref={(ref) => (inputRef.current[index] = ref)}
                        ></Input>
                      </td>
                      <td
                        style={{ border: 'none', backgroundColor: 'white', verticalAlign: 'middle', width: '20%' }}
                        className="min"
                      >
                        <Row justify="center">
                          <PlusCircleFilled
                            onClick={() => addItaatsu(item.no, index + 1)}
                            className="add-remove-icon"
                            style={{ marginLeft: 5, marginRight: 5, pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                          <CloseCircleFilled
                            className="add-remove-icon"
                            onClick={(e) => deleteItaatsu(item.no, e, index)}
                            style={{ pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                        </Row>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
      <Row justify="center" className="mt-2">
        <Button
          className={isEmpty(errIndexVal) ? 'mainButton' : 'disabledButton'}
          id="update"
          onClick={(e) => {
            okItaatsuMaster(true);
          }}
        >
          OK
        </Button>
        <Button className="cancelButton" style={{ marginLeft: 10 }} id="discard" onClick={cancelMasterData}>
          キャンセル
        </Button>
      </Row>
    </>
  );

  const changeKakouJikan = (event, no) => {
    // const copyData = [...detailsList];
    // const updatedData = JSON.parse(JSON.stringify(copyData));
    // updatedData[rowIndex].lstData[colIndex].value = event;
    // setDetailsList(updatedData);
    // props.updatedIQ3KakouJikanList(updatedData);
    detailsList
      ?.filter((item) => item.no === no)
      ?.map((list) => {
        list.value = event;
      });
    setDetailsList(detailsList);
    props.updatedIQ3KakouJikanList(detailsList);
  };

  const handleModeChange = (e, listData, listHoleData, isUsedEasyWorkSpeed) => {
    // 簡易入力と詳細入力を連動しないため、コメントアウトする。
    // IQX_WEBEST-265
    // let detailDisplay = false;
    // let isDetail = false;
    // // 加工種類 / サイズチェック
    // if (listData) {
    //   const usedItems = zaishitsuData?.filter((item) => item.info.isUsed);
    //   Object.keys(listData)
    //     .filter(([sizeDataKey]) => getProcessDetailTypeName(parseInt(sizeDataKey), processMstRecord) !== undefined)
    //     ?.map(([typeKey, item], rowIndex) => {
    //       listData[typeKey]?.map((item, workTimeSizeIndex) => {
    //         // サイズ
    //         if (item?.workTimeThickThItems) {
    //           let sameVal = item?.workTimeThickThItems[usedItems?.[0]?.id]?.[0]?.value;
    //           usedItems?.map((materialTypeItem) => {
    //             item?.workTimeThickThItems[materialTypeItem?.id]?.map((thickItem, index) => {
    //               if (
    //                 document.getElementById(typeKey + 'type' + item.no + 'cls' + materialTypeItem?.id + 'input' + index)
    //               ) {
    //                 document.getElementById(
    //                   typeKey + 'type' + item.no + 'cls' + materialTypeItem?.id + 'input' + index
    //                 ).style.backgroundColor = 'rgb(201 132 132 / 0%)';
    //               }
    //               if (Number(thickItem.value) !== Number(sameVal)) {
    //                 detailDisplay = true;
    //                 isDetail = true;
    //                 return;
    //               }
    //             });
    //           });
    //         }
    //         if (detailDisplay) {
    //           // IQX_WEBEST-297 詳細表示で簡易表示をクリックした時だけ赤く表示してほしい
    //           detailDisplay = false;
    //           if (item?.workTimeThickThItems) {
    //             const usedItems = zaishitsuData?.filter((item) => item.info.isUsed);
    //             usedItems?.map((materialTypeItem) => {
    //               Object.keys(item?.workTimeThickThItems)
    //                 ?.filter((listkey) => parseInt(listkey) === materialTypeItem.id)
    //                 ?.map((thickKey) => {
    //                   item?.workTimeThickThItems[thickKey]?.map((thickItem, index) => {
    //                     if (document.getElementById(typeKey + 'type' + item.no + 'cls' + thickKey + 'input' + index)) {
    //                       document.getElementById(
    //                         typeKey + 'type' + item.no + 'cls' + thickKey + 'input' + index
    //                       ).style.backgroundColor = 'rgb(201 132 132 / 36%)';
    //                     }
    //                   });
    //                 });
    //             });
    //           }
    //         } else {
    //           // IQX_WEBEST-296 簡易入力と詳細入力を切り替える際には値を引き継げるようにしてほしい
    //           if (item?.workTimeThickThItems && e === 'details') {
    //             usedItems?.map((materialTypeItem) => {
    //               item?.workTimeThickThItems[materialTypeItem?.id]?.map((thickItem, index) => {
    //                 thickItem.value = item?.value;
    //               });
    //             });
    //           } else if (item?.workTimeThickThItems && e === 'simple' && props?.editMode) {
    //             item.value = item?.workTimeThickThItems?.[usedItems?.[0]?.id]?.[0]?.value;
    //           }
    //         }
    //       });
    //     });
    // }
    // // 加工種類 / mmチェック
    // detailDisplay = false;
    // if (listHoleData) {
    //   const usedItems = zaishitsuData?.filter((item) => item.info.isUsed);
    //   Object.keys(listHoleData)
    //     .filter(([sizeDataKey]) => getProcessDetailTypeName(parseInt(sizeDataKey), processMstRecord) !== undefined)
    //     ?.map(([typeKey, item], rowIndex) => {
    //       listHoleData[typeKey]?.map((item, workTimeSizeIndex) => {
    //         // サイズ
    //         if (item?.workTimeThickThItems) {
    //           let sameVal = item?.workTimeThickThItems[usedItems?.[0]?.id]?.[0]?.value;
    //           usedItems?.map((materialTypeItem) => {
    //             item?.workTimeThickThItems[materialTypeItem?.id]?.map((thickItem, index) => {
    //               if (
    //                 document.getElementById(
    //                   'mm' + typeKey + 'type' + item.no + 'cls' + materialTypeItem?.id + 'input' + index
    //                 )
    //               ) {
    //                 document.getElementById(
    //                   'mm' + typeKey + 'type' + item.no + 'cls' + materialTypeItem?.id + 'input' + index
    //                 ).style.backgroundColor = 'rgb(201 132 132 / 0%)';
    //               }
    //               if (Number(thickItem.value) !== Number(sameVal)) {
    //                 detailDisplay = true;
    //                 isDetail = true;
    //                 return;
    //               }
    //             });
    //           });
    //         }
    //         if (detailDisplay) {
    //           // QX_WEBEST-297 詳細表示で簡易表示をクリックした時だけ赤く表示してほしい
    //           detailDisplay = false;
    //           if (item?.workTimeThickThItems) {
    //             const usedItems = zaishitsuData?.filter((item) => item.info.isUsed);
    //             usedItems?.map((materialTypeItem) => {
    //               Object.keys(item?.workTimeThickThItems)
    //                 ?.filter((listkey) => parseInt(listkey) === materialTypeItem.id)
    //                 ?.map((thickKey) => {
    //                   item?.workTimeThickThItems[thickKey]?.map((thickItem, index) => {
    //                     if (
    //                       document.getElementById(
    //                         'mm' + typeKey + 'type' + item.no + 'cls' + thickKey + 'input' + index
    //                       )
    //                     ) {
    //                       document.getElementById(
    //                         'mm' + typeKey + 'type' + item.no + 'cls' + thickKey + 'input' + index
    //                       ).style.backgroundColor = 'rgb(201 132 132 / 36%)';
    //                     }
    //                   });
    //                 });
    //             });
    //           }
    //         } else {
    //           // IQX_WEBEST-296 簡易入力と詳細入力を切り替える際には値を引き継げるようにしてほしい
    //           if (item?.workTimeThickThItems && e === 'details') {
    //             usedItems?.map((materialTypeItem) => {
    //               item?.workTimeThickThItems[materialTypeItem?.id]?.map((thickItem, index) => {
    //                 thickItem.value = item?.value;
    //               });
    //             });
    //           } else if (item?.workTimeThickThItems && e === 'simple' && props?.editMode) {
    //             item.value = item?.workTimeThickThItems?.[usedItems?.[0]?.id]?.[0]?.value;
    //           }
    //         }
    //       });
    //     });
    // }

    if (e != '') {
      setMode(e);
      if (e != '' && e === 'simple') {
        setIsUsedEasyWorkSpeed(true);
        props.updateIsUsedEasyWorkSpeedVal(true);
      } else {
        setIsUsedEasyWorkSpeed(false);
        props.updateIsUsedEasyWorkSpeedVal(false);
      }
    } else {
      setIsUsedEasyWorkSpeed(isUsedEasyWorkSpeed);
      if (isUsedEasyWorkSpeed) {
        setMode('simple');
      } else {
        setMode('details');
      }
      props.updateIsUsedEasyWorkSpeedVal(isUsedEasyWorkSpeed);
    }
  };

  // サイズ／mmのリスト値を変更した場合、
  const listDataChange = (value, rowIndex, colIndex, tblName) => {
    let updatedData;
    if (tblName === 'size') {
      updatedData = { ...kaniListData };
    } else if (tblName === 'mm') {
      updatedData = { ...kaniAnaListData };
    } else if (tblName === 'work') {
      updatedData = { ...detailsList };
    } else if (tblName === 'mm_multiProc') {
      updatedData = { ...kaniMultiProcAnaListData };
    }
    Object.entries(updatedData)
      ?.find(([rowKey]) => parseInt(rowKey) === parseInt(rowIndex))?.[1]
      ?.map((colValue) => {
        if (colValue && colValue.no === colIndex) {
          colValue.value = setTimetoSec(value);
        }
      });
    if (tblName === 'size') {
      setKaniListData(updatedData);
      props.updatediq3KaniListData(updatedData);
    } else if (tblName === 'mm') {
      setKaniAnaListData(updatedData);
      props.updateiq3KaniAnaListData(updatedData);
    } else if (tblName === 'work') {
      setDetailsList(updatedData);
      props.updatediq3KaniListData(updatedData);
    } else if (tblName === 'mm_multiProc') {
      setKaniMultiProcAnaListData(updatedData);
      props.updateiq3KaniMultiProcAnaListData(updatedData);
    }
  };

  const handleInputChange = (event, rowIndex, colIndex) => {
    const copyData = { ...kaniListData };
    const updatedData = JSON.parse(JSON.stringify(copyData));
    updatedData[rowIndex].lstData[colIndex].value = event.target.value;
    setKaniListData(updatedData);
    props.updatediq3KaniListData(updatedData);
  };

  // 板厚リスト値を変更した場合、
  const itaatsulistDataChange = (value, rowIndex, colIndex, subrowIndex, subcolIndex, tblName) => {
    setBtnEnable(false);
    let updatedData;
    if (tblName === 'size') {
      //updatedData = { ...kaniListData };
      updatedData = JSON.parse(JSON.stringify(kaniListData));
    } else if (tblName === 'mm') {
      // updatedData = { ...kaniAnaListData };
      updatedData = JSON.parse(JSON.stringify(kaniAnaListData));
    } else if (tblName === 'mm_multiProc') {
      updatedData = JSON.parse(JSON.stringify(kaniMultiProcAnaListData));
    }
    Object.entries(updatedData)
      ?.find(([rowKey]) => parseInt(rowKey) === parseInt(rowIndex))?.[1]
      ?.map((colValue) => {
        if (colValue.no === colIndex) {
          Object.entries(colValue?.workTimeThickThItems)
            ?.find(([subrowKey]) => parseInt(subrowKey) === parseInt(subrowIndex))?.[1]
            ?.map((subcolValue) => {
              if (subcolValue && subcolValue.no === subcolIndex) {
                subcolValue.value = setTimetoSec(value);
              }
            });
        }
      });
    if (tblName === 'size') {
      setKaniListData(updatedData);
      props.updatediq3KaniListData(updatedData);
    } else if (tblName === 'mm') {
      setKaniAnaListData(updatedData);
      props.updateiq3KaniAnaListData(updatedData);
    } else if (tblName === 'mm_multiProc') {
      props.updateiq3KaniMultiProcAnaListData(updatedData);
    }
  };

  // One by oneを変更した場合、
  const changeflag = (e) => {
    const isChecked = e.target.checked;
    setFlag(isChecked);
    props.updateShirringFlag(e.target.checked);
  };

  // 1カット時間を変更した場合、
  const changeTime = (e) => {
    setCutTime(setTimetoSec(e));
    props.updateCutTime(setTimetoSec(e));
  };

  return (
    <>
      {category === WorkType.SmShearing ? (
        // シャーリング
        <>
          <Row className="chargeAmount" style={{ marginLeft: 10, marginRight: 10 }}>
            <Table style={{ width: '40%' }}>
              <thead>
                <tr style={{ textAlign: 'center' }}>
                  <td style={{ width: '20%' }} className="param-tbl-header">
                    1カット時間
                  </td>
                  <td style={{ width: '20%' }} className="param-tbl-header">
                    One by one
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr style={{ textAlign: 'center' }}>
                  <td>
                    <Row align="middle">
                      {!editMode ? (
                        <>
                          <Col span={24}>
                            <label>{secondsToHms(cutTime)}</label>
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col>
                            <TimeInputParameterScreen
                              value={secondsToHms(cutTime)}
                              onBlur={(e) => {
                                changeTime(e.target.value);
                              }}
                            />
                          </Col>
                          {/* 2025-05-21 パラメータで複合機の二工程穴加工時間を編集する際に、
                              画面の横幅を狭くすると▲▼が2段になってしまう。
                              ▲▼が存在する部分は全てこの現象が起きると思う。
                              可能であれば画面の横幅の変更によって2段に別れたりしないようにしてほしい */}
                          <Col flex="1 1 auto">
                            <div
                              style={{
                                display: 'flex',
                                flexWrap: 'nowrap',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: 1,
                                overflow: 'hidden',
                              }}
                            >
                              {[
                                ['10min', 'up'],
                                ['10min', 'down'],
                                ['min', 'up'],
                                ['min', 'down'],
                                ['sec', 'up'],
                                ['sec', 'down'],
                              ].map(([unit, dir], i) => {
                                const Icon = dir === 'up' ? CaretUpOutlined : CaretDownOutlined;
                                return (
                                  <Icon
                                    key={i}
                                    style={{
                                      fontSize: 'clamp(12px, 1.4vw, 16px)',
                                      color: '#000',
                                      pointerEvents: editMode ? 'auto' : 'none',
                                      flexShrink: 0,
                                    }}
                                    onClick={() => {
                                      const fn = dir === 'up' ? souchiHandleIncreaseTime : souchiHandleDecreaseTime;
                                      const editedTime = fn(secondsToHms(cutTime), unit);
                                      changeTime(editedTime);
                                    }}
                                  />
                                );
                              })}
                            </div>
                          </Col>
                        </>
                      )}
                    </Row>
                  </td>
                  <td>
                    <Checkbox
                      style={{ pointerEvents: editMode ? 'auto' : 'none' }}
                      checked={flag}
                      onChange={changeflag}
                    ></Checkbox>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Row>
        </>
      ) : category === WorkType.SmDeburringAuto ? (
        <>
          <Row className="table-container" style={{ marginLeft: 10, marginRight: 10 }}>
            <Table
              style={{
                width:
                  areaData?.filter((i) => i.isOutOfRange === false)?.length > 4
                    ? '100%'
                    : areaData?.filter((i) => i.isOutOfRange === false)?.length * 210 + 196 + 'px',
              }}
            >
              <tr style={{ textAlign: 'center' }}>
                <td style={{ width: '196px' }} className="param-tbl-header fixedCol">
                  <Row justify="center" className="ant-row-no-bg-color">
                    {editMode ? (
                      <>
                        <Space>
                          <label>加工時間</label>
                          <label>/</label>
                          <Button className="cancleButton" onClick={addLength} style={{ pointerEvents: 'auto' }}>
                            cm<sup>2</sup>
                          </Button>
                        </Space>
                      </>
                    ) : (
                      <>
                        <Space>
                          <label>加工時間</label>
                          <label>/</label>
                          <label>
                            cm<sup>2</sup>
                          </label>
                        </Space>
                      </>
                    )}
                  </Row>
                </td>

                {areaData
                  ?.filter((subitem) => subitem.isOutOfRange === false)
                  ?.map((item) => (
                    <td style={{ width: '210px' }} className="param-tbl-header">
                      ～{item.value}cm<sup className="param-tbl-header">2</sup> {/**IQX_WEBEST-269*/}
                    </td>
                  ))}
              </tr>

              <tr style={{ textAlign: 'center' }}>
                <td style={{ width: '196px' }} className="param-tbl-header fixedCol">
                  加工時間
                </td>
                {detailsList?.map((item, index) => (
                  <td key={index} style={{ verticalAlign: 'middle', textAlign: 'center', width: 210 }}>
                    <Row align="middle">
                      {!editMode ? (
                        <>
                          <Col span={24}>
                            <label>{secondsToHms(item.value)}</label>
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col span={10}>
                            {/* <Input
                              value={secondsToHms(item.value)}
                              onChange={(e) => changeKakouJikan(setTimetoSec(e.target.value), item.no)}
                            ></Input> */}
                            <TimeInputParameterScreen
                              value={secondsToHms(item.value)}
                              onBlur={(e) => changeKakouJikan(setTimetoSec(e.target.value), item.no)}
                            />
                          </Col>
                          <Col span={14}>
                            <CaretUpOutlined
                              style={{
                                fontSize: 16 + 'px',
                                marginLeft: 3,
                                pointerEvents: 'auto',
                              }}
                              onClick={() => {
                                let editedTime = souchiHandleIncreaseTime(secondsToHms(item.value), '10min');

                                changeKakouJikan(setTimetoSec(editedTime), item.no);
                              }}
                            />
                            <CaretDownOutlined
                              style={{
                                fontSize: 17 + 'px',
                                color: '#000',
                                pointerEvents: 'auto',
                              }}
                              onClick={() => {
                                let editedTime = souchiHandleDecreaseTime(secondsToHms(item.value), '10min');
                                changeKakouJikan(setTimetoSec(editedTime), item.no);
                              }}
                            />
                            <CaretUpOutlined
                              style={{
                                fontSize: 17 + 'px',
                                color: '#000',
                                pointerEvents: 'auto',
                              }}
                              onClick={() => {
                                let editedTime = souchiHandleIncreaseTime(secondsToHms(item.value), 'min');
                                changeKakouJikan(setTimetoSec(editedTime), item.no);
                              }}
                            />
                            <CaretDownOutlined
                              style={{
                                fontSize: 17 + 'px',
                                color: '#000',
                                pointerEvents: 'auto',
                              }}
                              onClick={() => {
                                let editedTime = souchiHandleDecreaseTime(secondsToHms(item.value), 'min');
                                changeKakouJikan(setTimetoSec(editedTime), item.no);
                              }}
                            />
                            <CaretUpOutlined
                              style={{
                                fontSize: 17 + 'px',
                                color: '#000',
                                pointerEvents: 'auto',
                              }}
                              onClick={() => {
                                let editedTime = souchiHandleIncreaseTime(secondsToHms(item.value), 'sec');
                                changeKakouJikan(setTimetoSec(editedTime), item.no);
                              }}
                            />
                            <CaretDownOutlined
                              style={{
                                fontSize: 17 + 'px',
                                color: '#000',
                                pointerEvents: 'auto',
                              }}
                              onClick={() => {
                                let editedTime = souchiHandleDecreaseTime(secondsToHms(item.value), 'sec');
                                changeKakouJikan(setTimetoSec(editedTime), item.no);
                              }}
                            />
                          </Col>
                        </>
                      )}
                    </Row>
                  </td>
                ))}
              </tr>
            </Table>
          </Row>
        </>
      ) : category === WorkType.PaSurface || category === WorkType.SmSurface ? (
        <>
          <Row className="table-container" style={{ marginLeft: 10, marginRight: 10 }}>
            <Table
              style={{
                width:
                  areaData?.filter((i) => i.isOutOfRange === false)?.length > 4
                    ? '100%'
                    : areaData?.filter((i) => i.isOutOfRange === false)?.length * 210 + 196 + 'px',
              }}
            >
              <tr style={{ textAlign: 'center' }}>
                <td style={{ width: '196px' }} className="param-tbl-header fixedCol">
                  <Row justify="center" className="ant-row-no-bg-color">
                    {editMode ? (
                      <>
                        <Space>
                          <label>表面処理</label>
                          <label>/</label>
                          <Button className="cancleButton" onClick={addLength} style={{ pointerEvents: 'auto' }}>
                            cm<sup>2</sup>
                          </Button>
                        </Space>
                      </>
                    ) : (
                      <>
                        <Space>
                          <label>表面処理</label>
                          <label>/</label>
                          <label>
                            cm<sup>2</sup>
                          </label>
                        </Space>
                      </>
                    )}
                  </Row>
                </td>

                {areaData
                  ?.filter((subitem) => subitem.isOutOfRange === false)
                  ?.map((item) => (
                    <td style={{ width: '210px' }} className="param-tbl-header">
                      ～{item.value}cm<sup className="param-tbl-header">2</sup> {/**IQX_WEBEST-269*/}
                    </td>
                  ))}
              </tr>

              {/* 加工種類・サイズのリスト */}
              {Object.entries(detailsList)
                ?.filter(([key]) => getProcessDetailTypeName(parseInt(key), processMstRecord) !== undefined)
                ?.map(([key, item], rowIndex) => (
                  <tr key={rowIndex} style={{ textAlign: 'center' }}>
                    <td style={{ width: '98px', textAlign: 'center' }} className="param-tbl-header fixedCol2">
                      {/* 工程詳細名 */}
                      {getProcessDetailTypeName(parseInt(key), processMstRecord)}
                    </td>
                    {/* リスト情報 */}
                    {item?.map((col, colIndex) => (
                      <td
                        key={colIndex}
                        style={{
                          width:
                            mode === 'simple'
                              ? '210px'
                              : sizeItaatsu?.filter((i) => !i.isOutOfRange)?.length * 210 + 'px',
                          padding: 0,
                        }}
                      >
                        {/* リスト */}
                        <>
                          <Row align="middle" style={{ padding: 3 }}>
                            {!editMode ? (
                              <>
                                <Col span={24}>
                                  <label>{secondsToHms(col.value)}</label>
                                </Col>
                              </>
                            ) : (
                              <>
                                <Col span={10}>
                                  {/* <Input
                                    value={secondsToHms(col.value)}
                                    onChange={(e) => listDataChange(e.target.value, key, col.no, 'work')}
                                  ></Input> */}
                                  <TimeInputParameterScreen
                                    value={secondsToHms(col.value)}
                                    onBlur={(e) => listDataChange(e.target.value, key, col.no, 'work')}
                                  />
                                </Col>
                                <Col span={14}>
                                  <CaretUpOutlined
                                    style={{
                                      fontSize: 16 + 'px',
                                      marginLeft: 3,
                                      pointerEvents: 'auto',
                                    }}
                                    onClick={() => {
                                      let editedTime = souchiHandleIncreaseTime(secondsToHms(col.value), '10min');
                                      listDataChange(editedTime, key, col.no, 'work');
                                    }}
                                  />
                                  <CaretDownOutlined
                                    style={{
                                      fontSize: 17 + 'px',
                                      color: '#000',
                                      pointerEvents: 'auto',
                                    }}
                                    onClick={() => {
                                      let editedTime = souchiHandleDecreaseTime(secondsToHms(col.value), '10min');
                                      listDataChange(editedTime, key, col.no, 'work');
                                    }}
                                  />
                                  <CaretUpOutlined
                                    style={{
                                      fontSize: 17 + 'px',
                                      color: '#000',
                                      pointerEvents: 'auto',
                                    }}
                                    onClick={() => {
                                      let editedTime = souchiHandleIncreaseTime(secondsToHms(col.value), 'min');
                                      listDataChange(editedTime, key, col.no, 'work');
                                    }}
                                  />
                                  <CaretDownOutlined
                                    style={{
                                      fontSize: 17 + 'px',
                                      color: '#000',
                                      pointerEvents: 'auto',
                                    }}
                                    onClick={() => {
                                      let editedTime = souchiHandleDecreaseTime(secondsToHms(col.value), 'min');
                                      listDataChange(editedTime, key, col.no, 'work');
                                    }}
                                  />
                                  <CaretUpOutlined
                                    style={{
                                      fontSize: 17 + 'px',
                                      color: '#000',
                                      pointerEvents: 'auto',
                                    }}
                                    onClick={() => {
                                      let editedTime = souchiHandleIncreaseTime(secondsToHms(col.value), 'sec');
                                      listDataChange(editedTime, key, col.no, 'work');
                                    }}
                                  />
                                  <CaretDownOutlined
                                    style={{
                                      fontSize: 17 + 'px',
                                      color: '#000',
                                      pointerEvents: 'auto',
                                    }}
                                    onClick={() => {
                                      let editedTime = souchiHandleDecreaseTime(secondsToHms(col.value), 'sec');
                                      listDataChange(editedTime, key, col.no, 'work');
                                    }}
                                  />
                                </Col>
                              </>
                            )}
                          </Row>
                        </>
                      </td>
                    ))}
                  </tr>
                ))}
            </Table>
          </Row>
        </>
      ) : category === WorkType.SmSecondaryWork ? (
        // 2次加工
        <>
          <div style={{ marginLeft: 10, marginRight: 10 }}>
            <Row>
              <Col span={5}>
                <Radio.Group
                  onChange={(e) => {
                    // IQX_WEBEST-295「編集」状態に入っていない場合（表示のみ）：ラジオボタンの選択変更ができないように修正。
                    if (props?.editMode) {
                      handleModeChange(e.target.value, kaniListData, kaniAnaListData, isUsedEasyWorkSpeed);
                    }
                  }}
                  value={mode}
                  style={{ marginBottom: 8 }}
                >
                  <Radio.Button value="simple">簡易入力</Radio.Button>
                  <Radio.Button value="details">詳細入力</Radio.Button>
                </Radio.Group>
              </Col>
              <Col span={15} style={{ marginTop: 5 }}>
                <Radio.Group
                  name="isUsedEasyWorkSpeed"
                  defaultValue={true}
                  className="radioCustomerGpEdit"
                  onChange={(e) => {
                    // IQX_WEBEST-295「編集」状態に入っていない場合（表示のみ）：ラジオボタンの選択変更ができないように修正。
                    if (props?.editMode) {
                      setIsUsedEasyWorkSpeed(e.target.value);
                      handleModeChange('', kaniListData, kaniAnaListData, e.target.value);
                    }
                  }}
                  value={isUsedEasyWorkSpeed}
                >
                  <Radio value={true}>簡易入力値で計算</Radio>
                  <Radio value={false}>詳細入力値で計算</Radio>
                </Radio.Group>
              </Col>
            </Row>
            {/* 加工種類・サイズ */}
            <Row className="table-container">
              <Table
                style={{
                  width:
                    sizeData?.filter((i) => !i.isOutOfRange)?.length > 8
                      ? '100%'
                      : sizeData?.filter((i) => !i.isOutOfRange)?.length * 98 + 196 + 'px',
                }}
              >
                {/* 加工種類・サイズのヘッダー */}
                <tr style={{ textAlign: 'center' }}>
                  <td style={{ width: '196px' }} className="param-tbl-header fixedCol">
                    <Row justify="center" className="ant-row-no-bg-color">
                      <Space>
                        加工種類 /
                        {editMode ? (
                          <>
                            <Button className="cancleButton" onClick={size} style={{ pointerEvents: 'auto' }}>
                              サイズ
                            </Button>
                          </>
                        ) : (
                          <>
                            <label>サイズ</label>
                          </>
                        )}
                      </Space>
                    </Row>
                  </td>
                  {mode === 'simple' ? (
                    <></>
                  ) : (
                    <>
                      <td style={{ width: '196px' }} className="zaishitsukubun_header_fixedCol"></td>
                    </>
                  )}
                  {/* 加工種類・サイズのヘッダー */}
                  {sizeData
                    ?.filter((subitem) => !subitem.isOutOfRange)
                    ?.map((item, index) => (
                      <td
                        className="param-tbl-header"
                        key={index}
                        style={{
                          width:
                            mode === 'simple'
                              ? '100px'
                              : sizeItaatsu?.filter((i) => !i.isOutOfRange)?.length * 100 + 'px',
                        }}
                      >
                        ～M{item.value}
                      </td>
                    ))}
                </tr>

                {/* 加工種類・サイズのリスト */}
                {Object.entries(kaniListData)
                  ?.filter(
                    ([sizeDataKey]) => getProcessDetailTypeName(parseInt(sizeDataKey), processMstRecord) !== undefined
                  )
                  ?.map(([key, item], rowIndex) => (
                    <tr key={rowIndex} style={{ textAlign: 'center' }}>
                      <td style={{ width: '98px', textAlign: 'center' }} className="param-tbl-header fixedCol2">
                        {/* 工程詳細名 */}
                        {getProcessDetailTypeName(parseInt(key), processMstRecord)}
                      </td>
                      {mode === 'simple' ? (
                        <></>
                      ) : (
                        <>
                          <td style={{ width: '98px', padding: '0px' }} className="zaishitsukubun_fixedCol">
                            <Row className="kakoujikan" style={{ padding: 0 }}>
                              <Table className="zaishitsu" style={{ marginBottom: 0 }}>
                                {rowIndex === 0 ? (
                                  <>
                                    <tr style={{ textAlign: 'center', height: 48 }}>
                                      <td className="removeTopborder param-tbl-header" style={{ borderTop: 'none' }}>
                                        <Row justify="center" className="param-tbl-header">
                                          <Space>
                                            材質区分 /
                                            {editMode ? (
                                              <>
                                                <Button
                                                  className="cancleButton"
                                                  onClick={sizeThickness}
                                                  style={{ pointerEvents: 'auto' }}
                                                >
                                                  板厚
                                                </Button>
                                              </>
                                            ) : (
                                              <>
                                                <label>板厚</label>
                                              </>
                                            )}
                                          </Space>
                                        </Row>
                                      </td>
                                    </tr>
                                  </>
                                ) : (
                                  <></>
                                )}

                                {/* 材質区分名 */}
                                {zaishitsuData
                                  ?.filter((zaishitsuItem) => zaishitsuItem.info.isUsed)
                                  ?.map((disInfo, zIndex, zArray, index) => (
                                    <tr key={index} style={{ textAlign: 'center', height: 36 }}>
                                      <td
                                        style={{
                                          borderBottom: zArray?.length - 1 === zIndex ? 'none' : '',
                                          borderTop: zIndex === 0 ? 'auto' : '',
                                        }}
                                      >
                                        {getMaterialTypeById(parseInt(disInfo.id), zaishitsuData)}
                                      </td>
                                    </tr>
                                  ))}
                              </Table>
                            </Row>
                          </td>
                        </>
                      )}
                      {/* リスト情報 */}
                      {item?.map((col, colIndex) => (
                        <td
                          key={colIndex}
                          style={{
                            width:
                              mode === 'simple'
                                ? '110px'
                                : sizeItaatsu?.filter((i) => !i.isOutOfRange)?.length * 100 + 'px',
                            padding: 0,
                          }}
                        >
                          {mode === 'simple' ? (
                            // 簡易入力リスト
                            <>
                              <Row align="middle" style={{ padding: 3 }}>
                                {!editMode ? (
                                  <>
                                    <Col span={24}>
                                      <label>{secondsToHms(col.value)}</label>
                                    </Col>
                                  </>
                                ) : (
                                  <>
                                    <Col span={24}>
                                      {/* <Input
                                        style={{ textAlign: 'center' }}
                                        value={secondsToHms(col.value)}
                                        onChange={(e) => listDataChange(e.target.value, key, col.no, 'size')}
                                      ></Input> */}
                                      <TimeInputParameterScreen
                                        value={secondsToHms(col.value)}
                                        onBlur={(e) => listDataChange(e.target.value, key, col.no, 'size')}
                                      />
                                    </Col>
                                    {/** IQX_WEBEST-266 2次加工の加工時間に表示される▲▼を表示にして表を見やすくしてほしい */}
                                    {/* <Col span={14}>
                                      <CaretUpOutlined
                                        style={{
                                          fontSize: 16 + 'px',
                                          marginLeft: 3,
                                          pointerEvents: 'auto',
                                        }}
                                        onClick={() => {
                                          let editedTime = souchiHandleIncreaseTime(secondsToHms(col.value), '10min');
                                          listDataChange(editedTime, key, col.no, 'size');
                                        }}
                                      />
                                      <CaretDownOutlined
                                        style={{
                                          fontSize: 17 + 'px',
                                          color: '#000',
                                          pointerEvents: 'auto',
                                        }}
                                        onClick={() => {
                                          let editedTime = souchiHandleDecreaseTime(secondsToHms(col.value), '10min');
                                          listDataChange(editedTime, key, col.no, 'size');
                                        }}
                                      />
                                      <CaretUpOutlined
                                        style={{
                                          fontSize: 17 + 'px',
                                          color: '#000',
                                          pointerEvents: 'auto',
                                        }}
                                        onClick={() => {
                                          let editedTime = souchiHandleIncreaseTime(secondsToHms(col.value), 'min');
                                          listDataChange(editedTime, key, col.no, 'size');
                                        }}
                                      />
                                      <CaretDownOutlined
                                        style={{
                                          fontSize: 17 + 'px',
                                          color: '#000',
                                          pointerEvents: 'auto',
                                        }}
                                        onClick={() => {
                                          let editedTime = souchiHandleDecreaseTime(secondsToHms(col.value), 'min');
                                          listDataChange(editedTime, key, col.no, 'size');
                                        }}
                                      />
                                      <CaretUpOutlined
                                        style={{
                                          fontSize: 17 + 'px',
                                          color: '#000',
                                          pointerEvents: 'auto',
                                        }}
                                        onClick={() => {
                                          let editedTime = souchiHandleIncreaseTime(secondsToHms(col.value), 'sec');
                                          listDataChange(editedTime, key, col.no, 'size');
                                        }}
                                      />
                                      <CaretDownOutlined
                                        style={{
                                          fontSize: 17 + 'px',
                                          color: '#000',
                                          pointerEvents: 'auto',
                                        }}
                                        onClick={() => {
                                          let editedTime = souchiHandleDecreaseTime(secondsToHms(col.value), 'sec');
                                          listDataChange(editedTime, key, col.no, 'size');
                                        }}
                                      />
                                    </Col> */}
                                  </>
                                )}
                              </Row>
                            </>
                          ) : (
                            // 詳細入力リスト
                            <>
                              <Row className="subTbl">
                                <Table
                                  style={{
                                    marginBottom: 0,
                                    width: sizeItaatsu?.filter((i) => !i.isOutOfRange)?.length * 100 + 'px',
                                  }}
                                >
                                  {/* 板厚情報のヘッダー */}
                                  {rowIndex === 0 ? (
                                    <>
                                      <tr style={{ textAlign: 'center', height: 48 }}>
                                        {sizeItaatsu
                                          ?.filter((subitem) => !subitem.isOutOfRange)
                                          ?.map((item, index) => (
                                            <td
                                              key={index}
                                              style={{ width: '100px' }}
                                              className="removeTopborder param-tbl-header"
                                            >
                                              ～{item.value}t
                                            </td>
                                          ))}
                                      </tr>
                                    </>
                                  ) : (
                                    <></>
                                  )}

                                  {/* 材質区分・板厚リスト詳細情報 */}
                                  {Object.entries(col?.workTimeThickThItems)
                                    ?.filter(
                                      ([thickKey]) => getMaterialTypeById(parseInt(thickKey), zaishitsuData) !== ''
                                    )
                                    ?.map(([subRowKey, subRowItem], subRowIndex, subRowLists) => (
                                      <tr style={{ textAlign: 'center', height: 36 }}>
                                        {subRowItem?.map((subCol, subColIndex) => (
                                          <td
                                            key={subColIndex}
                                            style={{
                                              width: '100px',
                                              borderLeft: subColIndex === 0 ? 'none' : '',
                                              borderRight: subColIndex === subRowLists?.length - 1 ? 'none' : '',
                                              borderBottom: subRowIndex === subRowItem?.length - 1 ? 'none' : '',
                                              borderTop: subRowIndex === 0 ? 'none' : '',
                                            }}
                                          >
                                            <Row align="middle" style={{ padding: 1 }}>
                                              {!editMode ? (
                                                <>
                                                  <Col span={24}>
                                                    <Input
                                                      id={
                                                        key +
                                                        'type' +
                                                        col.no +
                                                        'cls' +
                                                        subRowKey +
                                                        'input' +
                                                        subColIndex
                                                      }
                                                      style={{
                                                        textAlign: 'center',
                                                        border: 'none',
                                                        pointerEvents: 'none',
                                                      }}
                                                      value={secondsToHms(subCol.value)}
                                                    ></Input>
                                                  </Col>
                                                </>
                                              ) : (
                                                <>
                                                  <Col span={24}>
                                                    {/* <Input
                                                      id={
                                                        key +
                                                        'type' +
                                                        col.no +
                                                        'cls' +
                                                        subRowKey +
                                                        'input' +
                                                        subColIndex
                                                      }
                                                      style={{
                                                        textAlign: 'center',
                                                      }}
                                                      value={secondsToHms(subCol.value)}
                                                      onChange={(e) =>
                                                        itaatsulistDataChange(
                                                          e.target.value,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'size'
                                                        )
                                                      }
                                                    ></Input> */}
                                                    <TimeInputParameterScreen
                                                      id={
                                                        key +
                                                        'type' +
                                                        col.no +
                                                        'cls' +
                                                        subRowKey +
                                                        'input' +
                                                        subColIndex
                                                      }
                                                      style={{
                                                        textAlign: 'center',
                                                      }}
                                                      value={secondsToHms(subCol.value)}
                                                      onBlur={(e) =>
                                                        itaatsulistDataChange(
                                                          e.target.value,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'size'
                                                        )
                                                      }
                                                    />
                                                  </Col>
                                                  {/** IQX_WEBEST-266 2次加工の加工時間に表示される▲▼を表示にして表を見やすくしてほしい */}
                                                  {/* <Col span={14}>
                                                    <CaretUpOutlined
                                                      style={{
                                                        fontSize: 16 + 'px',
                                                        marginLeft: 3,
                                                        pointerEvents: 'auto',
                                                      }}
                                                      onClick={() => {
                                                        let editedTime = souchiHandleIncreaseTime(
                                                          secondsToHms(subCol.value),
                                                          '10min'
                                                        );

                                                        itaatsulistDataChange(
                                                          editedTime,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'size'
                                                        );
                                                      }}
                                                    />
                                                    <CaretDownOutlined
                                                      style={{
                                                        fontSize: 17 + 'px',
                                                        color: '#000',
                                                        pointerEvents: 'auto',
                                                      }}
                                                      onClick={() => {
                                                        let editedTime = souchiHandleDecreaseTime(
                                                          secondsToHms(subCol.value),
                                                          '10min'
                                                        );
                                                        itaatsulistDataChange(
                                                          editedTime,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'size'
                                                        );
                                                      }}
                                                    />
                                                    <CaretUpOutlined
                                                      style={{
                                                        fontSize: 17 + 'px',
                                                        color: '#000',
                                                        pointerEvents: 'auto',
                                                      }}
                                                      onClick={() => {
                                                        let editedTime = souchiHandleIncreaseTime(
                                                          secondsToHms(subCol.value),
                                                          'min'
                                                        );
                                                        itaatsulistDataChange(
                                                          editedTime,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'size'
                                                        );
                                                      }}
                                                    />
                                                    <CaretDownOutlined
                                                      style={{
                                                        fontSize: 17 + 'px',
                                                        color: '#000',
                                                        pointerEvents: 'auto',
                                                      }}
                                                      onClick={() => {
                                                        let editedTime = souchiHandleDecreaseTime(
                                                          secondsToHms(subCol.value),
                                                          'min'
                                                        );
                                                        itaatsulistDataChange(
                                                          editedTime,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'size'
                                                        );
                                                      }}
                                                    />
                                                    <CaretUpOutlined
                                                      style={{
                                                        fontSize: 17 + 'px',
                                                        color: '#000',
                                                        pointerEvents: 'auto',
                                                      }}
                                                      onClick={() => {
                                                        let editedTime = souchiHandleIncreaseTime(
                                                          secondsToHms(subCol.value),
                                                          'sec'
                                                        );
                                                        itaatsulistDataChange(
                                                          editedTime,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'size'
                                                        );
                                                      }}
                                                    />
                                                    <CaretDownOutlined
                                                      style={{
                                                        fontSize: 17 + 'px',
                                                        color: '#000',
                                                        pointerEvents: 'auto',
                                                      }}
                                                      onClick={() => {
                                                        let editedTime = souchiHandleDecreaseTime(
                                                          secondsToHms(subCol.value),
                                                          'sec'
                                                        );
                                                        itaatsulistDataChange(
                                                          editedTime,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'size'
                                                        );
                                                      }}
                                                    />
                                                  </Col> */}
                                                </>
                                              )}
                                            </Row>
                                          </td>
                                        ))}
                                      </tr>
                                    ))}
                                </Table>
                              </Row>
                            </>
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
              </Table>
            </Row>
            {/* 加工種類・mm  (成形型穴)　*/}
            <Row className="table-container">
              <Table
                style={{
                  width:
                    anaSizeData?.filter((i) => !i.isOutOfRange)?.length > 8
                      ? '100%'
                      : anaSizeData?.filter((i) => !i.isOutOfRange)?.length * 98 + 196 + 'px',
                }}
              >
                {/* 加工種類・mmのヘッダー */}
                <tr style={{ textAlign: 'center' }}>
                  <td style={{ width: '196px' }} className="param-tbl-header fixedCol">
                    <Row justify="center" className="ant-row-no-bg-color">
                      <Space>
                        加工種類 /
                        {editMode ? (
                          <>
                            <Button
                              className="cancleButton"
                              onClick={() => anaSize(false)}
                              style={{ pointerEvents: 'auto' }}
                            >
                              mm
                            </Button>
                          </>
                        ) : (
                          <>
                            <label>mm</label>
                          </>
                        )}
                      </Space>
                    </Row>
                  </td>
                  {mode === 'simple' ? (
                    <></>
                  ) : (
                    <>
                      <td style={{ width: '196px' }} className="zaishitsukubun_header_fixedCol"></td>
                    </>
                  )}

                  {/* 加工種類・mmのヘッダー */}
                  {anaSizeData
                    ?.filter((subitem) => !subitem.isOutOfRange)
                    ?.map((item, index) => (
                      <td
                        className="param-tbl-header"
                        key={index}
                        style={{
                          width:
                            mode === 'simple'
                              ? '100px'
                              : mmItaatsu?.filter((i) => !i.isOutOfRange)?.length * 100 + 'px',
                        }}
                      >
                        ～{item.value}mm {/**IQX_WEBEST-269*/}
                      </td>
                    ))}
                </tr>

                {/* 加工種類・mmのリスト */}
                {Object.entries(kaniAnaListData)
                  ?.filter(
                    ([mmDataKey]) =>
                      getProcessDetailTypeName(parseInt(mmDataKey), processMstRecord) !== undefined &&
                      getProcessDetailTypeName(parseInt(mmDataKey), processMstRecord)?.includes('成形型')
                  )
                  ?.map(([key, item], rowIndex) => (
                    <tr key={rowIndex} style={{ textAlign: 'center' }}>
                      <td style={{ width: '98px', textAlign: 'center' }} className="param-tbl-header fixedCol2">
                        {/* 工程詳細名 */}
                        {getProcessDetailTypeName(parseInt(key), processMstRecord)}
                      </td>
                      {mode === 'simple' ? (
                        <></>
                      ) : (
                        <>
                          <td style={{ width: '98px', padding: '0px' }} className="zaishitsukubun_fixedCol">
                            <Row className="kakoujikan" style={{ padding: 0 }}>
                              <Table className="zaishitsu" style={{ marginBottom: 0 }}>
                                {rowIndex === 0 ? (
                                  <>
                                    <tr style={{ textAlign: 'center', height: 48 }}>
                                      <td className="removeTopborder param-tbl-header" style={{ borderTop: 'none' }}>
                                        <Row justify="center" className="param-tbl-header">
                                          <Space>
                                            材質区分 /
                                            {editMode ? (
                                              <>
                                                <Button
                                                  className="cancleButton"
                                                  onClick={mmThickness}
                                                  style={{ pointerEvents: 'auto' }}
                                                >
                                                  板厚
                                                </Button>
                                              </>
                                            ) : (
                                              <>
                                                <label>板厚</label>
                                              </>
                                            )}
                                          </Space>
                                        </Row>
                                      </td>
                                    </tr>
                                  </>
                                ) : (
                                  <></>
                                )}

                                {/* 材質区分名 */}
                                {zaishitsuData
                                  ?.filter((zaishitsuItem) => zaishitsuItem.info.isUsed)
                                  ?.map((disInfo, zIndex, zArray, index) => (
                                    <tr key={index} style={{ textAlign: 'center', height: 36 }}>
                                      <td
                                        style={{
                                          borderBottom: zArray?.length - 1 === zIndex ? 'none' : '',
                                          borderTop: zIndex === 0 ? 'auto' : '',
                                        }}
                                      >
                                        {getMaterialTypeById(parseInt(disInfo.id), zaishitsuData)}
                                      </td>
                                    </tr>
                                  ))}
                              </Table>
                            </Row>
                          </td>
                        </>
                      )}
                      {/* リスト情報 */}
                      {item?.map((col, colIndex) => (
                        <td
                          key={colIndex}
                          style={{
                            width:
                              mode === 'simple'
                                ? '100px'
                                : mmItaatsu?.filter((i) => !i.isOutOfRange)?.length * 100 + 'px',
                            padding: 0,
                          }}
                        >
                          {mode === 'simple' ? (
                            // 簡易入力リスト
                            <>
                              <Row align="middle" style={{ padding: 3 }}>
                                {!editMode ? (
                                  <>
                                    <Col span={24}>
                                      <label>{secondsToHms(col.value)}</label>
                                    </Col>
                                  </>
                                ) : (
                                  <>
                                    <Col span={24}>
                                      {/* <Input
                                        style={{ textAlign: 'center' }}
                                        value={secondsToHms(col.value)}
                                        onChange={(e) => listDataChange(e.target.value, key, col.no, 'mm')}
                                      ></Input> */}
                                      <TimeInputParameterScreen
                                        // style={{ textAlign: 'center' }}
                                        value={secondsToHms(col.value)}
                                        onBlur={(e) => listDataChange(e.target.value, key, col.no, 'mm')}
                                      />
                                    </Col>
                                    {/** IQX_WEBEST-266 2次加工の加工時間に表示される▲▼を表示にして表を見やすくしてほしい */}
                                    {/* <Col span={14}>
                                      <CaretUpOutlined
                                        style={{
                                          fontSize: 16 + 'px',
                                          marginLeft: 3,
                                          pointerEvents: 'auto',
                                        }}
                                        onClick={() => {
                                          let editedTime = souchiHandleIncreaseTime(secondsToHms(col.value), '10min');
                                          listDataChange(editedTime, key, col.no, 'mm');
                                        }}
                                      />
                                      <CaretDownOutlined
                                        style={{
                                          fontSize: 17 + 'px',
                                          color: '#000',
                                          pointerEvents: 'auto',
                                        }}
                                        onClick={() => {
                                          let editedTime = souchiHandleDecreaseTime(secondsToHms(col.value), '10min');
                                          listDataChange(editedTime, key, col.no, 'mm');
                                        }}
                                      />
                                      <CaretUpOutlined
                                        style={{
                                          fontSize: 17 + 'px',
                                          color: '#000',
                                          pointerEvents: 'auto',
                                        }}
                                        onClick={() => {
                                          let editedTime = souchiHandleIncreaseTime(secondsToHms(col.value), 'min');
                                          listDataChange(editedTime, key, col.no, 'mm');
                                        }}
                                      />
                                      <CaretDownOutlined
                                        style={{
                                          fontSize: 17 + 'px',
                                          color: '#000',
                                          pointerEvents: 'auto',
                                        }}
                                        onClick={() => {
                                          let editedTime = souchiHandleDecreaseTime(secondsToHms(col.value), 'min');
                                          listDataChange(editedTime, key, col.no, 'mm');
                                        }}
                                      />
                                      <CaretUpOutlined
                                        style={{
                                          fontSize: 17 + 'px',
                                          color: '#000',
                                          pointerEvents: 'auto',
                                        }}
                                        onClick={() => {
                                          let editedTime = souchiHandleIncreaseTime(secondsToHms(col.value), 'sec');
                                          listDataChange(editedTime, key, col.no, 'mm');
                                        }}
                                      />
                                      <CaretDownOutlined
                                        style={{
                                          fontSize: 17 + 'px',
                                          color: '#000',
                                          pointerEvents: 'auto',
                                        }}
                                        onClick={() => {
                                          let editedTime = souchiHandleDecreaseTime(secondsToHms(col.value), 'sec');
                                          listDataChange(editedTime, key, col.no, 'mm');
                                        }}
                                      />
                                    </Col> */}
                                  </>
                                )}
                              </Row>
                            </>
                          ) : (
                            // 詳細入力リスト
                            <>
                              <Row className="subTbl">
                                <Table
                                  style={{
                                    marginBottom: 0,
                                    width: mmItaatsu?.filter((i) => !i.isOutOfRange)?.length * 100 + 'px',
                                  }}
                                >
                                  {/* 板厚情報のヘッダー */}
                                  {rowIndex === 0 ? (
                                    <>
                                      <tr style={{ textAlign: 'center', height: 48 }}>
                                        {mmItaatsu
                                          ?.filter((subitem) => !subitem.isOutOfRange)
                                          ?.map((item, index) => (
                                            <td key={index} style={{ width: '100px' }} className="removeTopborder">
                                              ～{item.value}t
                                            </td>
                                          ))}
                                      </tr>
                                    </>
                                  ) : (
                                    <></>
                                  )}

                                  {/* 材質区分・板厚リスト詳細情報 */}
                                  {Object.entries(col?.workTimeThickThItems)
                                    ?.filter(
                                      ([thickKey]) => getMaterialTypeById(parseInt(thickKey), zaishitsuData) !== ''
                                    )
                                    ?.map(([subRowKey, subRowItem], subRowIndex, subRowLists) => (
                                      <tr style={{ textAlign: 'center', height: 36 }}>
                                        {subRowItem?.map((subCol, subColIndex) => (
                                          <td
                                            key={subColIndex}
                                            style={{
                                              width: '100px',
                                              borderLeft: subColIndex === 0 ? 'none' : '',
                                              borderRight: subColIndex === subRowLists?.length - 1 ? 'none' : '',
                                              borderBottom: subRowIndex === subRowItem?.length - 1 ? 'none' : '',
                                              borderTop: subRowIndex === 0 ? 'none' : '',
                                            }}
                                          >
                                            <Row align="middle" style={{ padding: 1 }}>
                                              {!editMode ? (
                                                <>
                                                  <Col span={24}>
                                                    <Input
                                                      id={
                                                        'mm' +
                                                        key +
                                                        'type' +
                                                        col.no +
                                                        'cls' +
                                                        subRowKey +
                                                        'input' +
                                                        subColIndex
                                                      }
                                                      style={{
                                                        textAlign: 'center',
                                                        border: 'none',
                                                        pointerEvents: 'none',
                                                      }}
                                                      value={secondsToHms(subCol.value)}
                                                    ></Input>
                                                  </Col>
                                                </>
                                              ) : (
                                                <>
                                                  <Col span={24}>
                                                    {/* <Input
                                                      id={
                                                        'mm' +
                                                        key +
                                                        'type' +
                                                        col.no +
                                                        'cls' +
                                                        subRowKey +
                                                        'input' +
                                                        subColIndex
                                                      }
                                                      style={{
                                                        textAlign: 'center',
                                                      }}
                                                      value={secondsToHms(subCol.value)}
                                                      onChange={(e) =>
                                                        itaatsulistDataChange(
                                                          e.target.value,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'mm'
                                                        )
                                                      }
                                                    ></Input> */}
                                                    <TimeInputParameterScreen
                                                      id={
                                                        'mm' +
                                                        key +
                                                        'type' +
                                                        col.no +
                                                        'cls' +
                                                        subRowKey +
                                                        'input' +
                                                        subColIndex
                                                      }
                                                      style={{
                                                        textAlign: 'center',
                                                      }}
                                                      value={secondsToHms(subCol.value)}
                                                      onBlur={(e) =>
                                                        itaatsulistDataChange(
                                                          e.target.value,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'mm'
                                                        )
                                                      }
                                                    />
                                                  </Col>
                                                  {/** IQX_WEBEST-266 2次加工の加工時間に表示される▲▼を表示にして表を見やすくしてほしい */}
                                                  {/* <Col span={14}>
                                                    <CaretUpOutlined
                                                      style={{
                                                        fontSize: 16 + 'px',
                                                        marginLeft: 3,
                                                        pointerEvents: 'auto',
                                                      }}
                                                      onClick={() => {
                                                        let editedTime = souchiHandleIncreaseTime(
                                                          secondsToHms(subCol.value),
                                                          '10min'
                                                        );

                                                        itaatsulistDataChange(
                                                          editedTime,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'mm'
                                                        );
                                                      }}
                                                    />
                                                    <CaretDownOutlined
                                                      style={{
                                                        fontSize: 17 + 'px',
                                                        color: '#000',
                                                        pointerEvents: 'auto',
                                                      }}
                                                      onClick={() => {
                                                        let editedTime = souchiHandleDecreaseTime(
                                                          secondsToHms(subCol.value),
                                                          '10min'
                                                        );
                                                        itaatsulistDataChange(
                                                          editedTime,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'mm'
                                                        );
                                                      }}
                                                    />
                                                    <CaretUpOutlined
                                                      style={{
                                                        fontSize: 17 + 'px',
                                                        color: '#000',
                                                        pointerEvents: 'auto',
                                                      }}
                                                      onClick={() => {
                                                        let editedTime = souchiHandleIncreaseTime(
                                                          secondsToHms(subCol.value),
                                                          'min'
                                                        );
                                                        itaatsulistDataChange(
                                                          editedTime,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'mm'
                                                        );
                                                      }}
                                                    />
                                                    <CaretDownOutlined
                                                      style={{
                                                        fontSize: 17 + 'px',
                                                        color: '#000',
                                                        pointerEvents: 'auto',
                                                      }}
                                                      onClick={() => {
                                                        let editedTime = souchiHandleDecreaseTime(
                                                          secondsToHms(subCol.value),
                                                          'min'
                                                        );
                                                        itaatsulistDataChange(
                                                          editedTime,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'mm'
                                                        );
                                                      }}
                                                    />
                                                    <CaretUpOutlined
                                                      style={{
                                                        fontSize: 17 + 'px',
                                                        color: '#000',
                                                        pointerEvents: 'auto',
                                                      }}
                                                      onClick={() => {
                                                        let editedTime = souchiHandleIncreaseTime(
                                                          secondsToHms(subCol.value),
                                                          'sec'
                                                        );
                                                        itaatsulistDataChange(
                                                          editedTime,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'mm'
                                                        );
                                                      }}
                                                    />
                                                    <CaretDownOutlined
                                                      style={{
                                                        fontSize: 17 + 'px',
                                                        color: '#000',
                                                        pointerEvents: 'auto',
                                                      }}
                                                      onClick={() => {
                                                        let editedTime = souchiHandleDecreaseTime(
                                                          secondsToHms(subCol.value),
                                                          'sec'
                                                        );
                                                        itaatsulistDataChange(
                                                          editedTime,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'mm'
                                                        );
                                                      }}
                                                    />
                                                  </Col> */}
                                                </>
                                              )}
                                            </Row>
                                          </td>
                                        ))}
                                      </tr>
                                    ))}
                                </Table>
                              </Row>
                            </>
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
              </Table>
            </Row>
            {/* 加工種類・mm (多工程穴) */}
            <Row className="table-container">
              <Table
                style={{
                  width:
                    anaSizeMultiProcData?.filter((i) => !i.isOutOfRange)?.length > 8
                      ? '100%'
                      : anaSizeMultiProcData?.filter((i) => !i.isOutOfRange)?.length * 98 + 196 + 'px',
                }}
              >
                {/* 加工種類・mmのヘッダー */}
                <tr style={{ textAlign: 'center' }}>
                  <td style={{ width: '196px' }} className="param-tbl-header fixedCol">
                    <Row justify="center" className="ant-row-no-bg-color">
                      <Space>
                        加工種類 /
                        {editMode ? (
                          <>
                            <Button
                              className="cancleButton"
                              onClick={() => {
                                anaSize(true);
                              }}
                              style={{ pointerEvents: 'auto' }}
                            >
                              mm
                            </Button>
                          </>
                        ) : (
                          <>
                            <label>mm</label>
                          </>
                        )}
                      </Space>
                    </Row>
                  </td>
                  {mode === 'simple' ? (
                    <></>
                  ) : (
                    <>
                      <td style={{ width: '196px' }} className="zaishitsukubun_header_fixedCol"></td>
                    </>
                  )}

                  {/* 加工種類・mmのヘッダー */}
                  {anaSizeMultiProcData
                    ?.filter((subitem) => !subitem.isOutOfRange)
                    ?.map((item, index) => (
                      <td
                        className="param-tbl-header"
                        key={index}
                        style={{
                          width:
                            mode === 'simple'
                              ? '100px'
                              : mmMultiProcHole?.filter((i) => !i.isOutOfRange)?.length * 100 + 'px',
                        }}
                      >
                        ～{item.value}mm {/**IQX_WEBEST-269*/}
                      </td>
                    ))}
                </tr>

                {/* 加工種類・mmのリスト */}
                {Object.entries(kaniMultiProcAnaListData)
                  ?.filter(
                    ([mmDataKey]) =>
                      getProcessDetailTypeName(parseInt(mmDataKey), processMstRecord) !== undefined &&
                      getProcessDetailTypeName(parseInt(mmDataKey), processMstRecord)?.includes('多工程')
                  )
                  ?.map(([key, item], rowIndex) => (
                    <tr key={rowIndex} style={{ textAlign: 'center' }}>
                      <td style={{ width: '98px', textAlign: 'center' }} className="param-tbl-header fixedCol2">
                        {/* 工程詳細名 */}
                        {getProcessDetailTypeName(parseInt(key), processMstRecord)}
                      </td>
                      {/* 詳細入力の場合材質区分/板厚 */}
                      {mode === 'simple' ? (
                        <></>
                      ) : (
                        <>
                          <td style={{ width: '98px', padding: '0px' }} className="zaishitsukubun_fixedCol">
                            <Row className="kakoujikan" style={{ padding: 0 }}>
                              <Table className="zaishitsu" style={{ marginBottom: 0 }}>
                                {rowIndex === 0 ? (
                                  <>
                                    <tr style={{ textAlign: 'center', height: 48 }}>
                                      <td className="removeTopborder param-tbl-header" style={{ borderTop: 'none' }}>
                                        <Row justify="center" className="param-tbl-header">
                                          <Space>
                                            材質区分 /
                                            {editMode ? (
                                              <>
                                                <Button
                                                  className="cancleButton"
                                                  onClick={() => {
                                                    setIsMultiProcAnaSize(true);
                                                    mmThickness();
                                                  }}
                                                  style={{ pointerEvents: 'auto' }}
                                                >
                                                  板厚
                                                </Button>
                                              </>
                                            ) : (
                                              <>
                                                <label>板厚</label>
                                              </>
                                            )}
                                          </Space>
                                        </Row>
                                      </td>
                                    </tr>
                                  </>
                                ) : (
                                  <></>
                                )}

                                {/* 材質区分名 */}
                                {zaishitsuData
                                  ?.filter((zaishitsuItem) => zaishitsuItem.info.isUsed)
                                  ?.map((disInfo, zIndex, zArray, index) => (
                                    <tr key={index} style={{ textAlign: 'center', height: 36 }}>
                                      <td
                                        style={{
                                          borderBottom: zArray?.length - 1 === zIndex ? 'none' : '',
                                          borderTop: zIndex === 0 ? 'auto' : '',
                                        }}
                                      >
                                        {getMaterialTypeById(parseInt(disInfo.id), zaishitsuData)}
                                      </td>
                                    </tr>
                                  ))}
                              </Table>
                            </Row>
                          </td>
                        </>
                      )}
                      {/* リスト情報 */}
                      {item?.map((col, colIndex) => (
                        <td
                          key={colIndex}
                          style={{
                            width:
                              mode === 'simple'
                                ? '100px'
                                : mmMultiProcHole?.filter((i) => !i.isOutOfRange)?.length * 100 + 'px',
                            padding: 0,
                          }}
                        >
                          {mode === 'simple' ? (
                            // 簡易入力リスト
                            <>
                              <Row align="middle" style={{ padding: 3 }}>
                                {!editMode ? (
                                  <>
                                    <Col span={24}>
                                      <label>{secondsToHms(col.value)}</label>
                                    </Col>
                                  </>
                                ) : (
                                  <>
                                    <Col span={24}>
                                      <TimeInputParameterScreen
                                        value={secondsToHms(col.value)}
                                        onBlur={(e) => listDataChange(e.target.value, key, col.no, 'mm_multiProc')}
                                      />
                                    </Col>
                                  </>
                                )}
                              </Row>
                            </>
                          ) : (
                            // 詳細入力リスト
                            <>
                              <Row className="subTbl">
                                <Table
                                  style={{
                                    marginBottom: 0,
                                    width: mmMultiProcHole?.filter((i) => !i.isOutOfRange)?.length * 100 + 'px',
                                  }}
                                >
                                  {/* 板厚情報のヘッダー */}
                                  {rowIndex === 0 ? (
                                    <>
                                      <tr style={{ textAlign: 'center', height: 48 }}>
                                        {mmMultiProcHole
                                          ?.filter((subitem) => !subitem.isOutOfRange)
                                          ?.map((item, index) => (
                                            <td key={index} style={{ width: '100px' }} className="removeTopborder">
                                              ～{item.value}t
                                            </td>
                                          ))}
                                      </tr>
                                    </>
                                  ) : (
                                    <></>
                                  )}

                                  {/* 材質区分・板厚リスト詳細情報 */}
                                  {Object.entries(col?.workTimeThickThItems)
                                    ?.filter(
                                      ([thickKey]) => getMaterialTypeById(parseInt(thickKey), zaishitsuData) !== ''
                                    )
                                    ?.map(([subRowKey, subRowItem], subRowIndex, subRowLists) => (
                                      <tr style={{ textAlign: 'center', height: 36 }}>
                                        {subRowItem?.map((subCol, subColIndex) => (
                                          <td
                                            key={subColIndex}
                                            style={{
                                              width: '100px',
                                              borderLeft: subColIndex === 0 ? 'none' : '',
                                              borderRight: subColIndex === subRowLists?.length - 1 ? 'none' : '',
                                              borderBottom: subRowIndex === subRowItem?.length - 1 ? 'none' : '',
                                              borderTop: subRowIndex === 0 ? 'none' : '',
                                            }}
                                          >
                                            <Row align="middle" style={{ padding: 1 }}>
                                              {!editMode ? (
                                                <>
                                                  <Col span={24}>
                                                    <Input
                                                      id={
                                                        'mm' +
                                                        key +
                                                        'type' +
                                                        col.no +
                                                        'cls' +
                                                        subRowKey +
                                                        'input' +
                                                        subColIndex
                                                      }
                                                      style={{
                                                        textAlign: 'center',
                                                        border: 'none',
                                                        pointerEvents: 'none',
                                                      }}
                                                      value={secondsToHms(subCol.value)}
                                                    ></Input>
                                                  </Col>
                                                </>
                                              ) : (
                                                <>
                                                  <Col span={24}>
                                                    <TimeInputParameterScreen
                                                      id={
                                                        'mm' +
                                                        key +
                                                        'type' +
                                                        col.no +
                                                        'cls' +
                                                        subRowKey +
                                                        'input' +
                                                        subColIndex
                                                      }
                                                      style={{
                                                        textAlign: 'center',
                                                      }}
                                                      value={secondsToHms(subCol.value)}
                                                      onBlur={(e) =>
                                                        itaatsulistDataChange(
                                                          e.target.value,
                                                          key,
                                                          col.no,
                                                          subRowKey,
                                                          subCol.no,
                                                          'mm_multiProc'
                                                        )
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              )}
                                            </Row>
                                          </td>
                                        ))}
                                      </tr>
                                    ))}
                                </Table>
                              </Row>
                            </>
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
              </Table>
            </Row>
          </div>
        </>
      ) : (
        <></>
      )}
      {/* mm */}
      {isLength
        ? commonModal(
            isLength,
            addLengthModalTitle,
            null,
            null,
            400,
            addData,
            closeAddModal,
            addLengthContent,
            null,
            null,
            true
          )
        : ''}
      {/* サイズ */}
      {isSize
        ? commonModal(
            isSize,
            addSizeModalTitle,
            null,
            null,
            400,
            addData,
            closeAddModal,
            addSizeContent,
            null,
            null,
            true
          )
        : ''}
      {/* 穴サイズ（成形型穴又は多工程穴） */}
      {isAnaSize || isMultiProcAnaSize
        ? commonModal(
            isAnaSize || isMultiProcAnaSize,
            addAnaSizeModalTitle,
            null,
            null,
            400,
            addData,
            closeAddModal,
            isMultiProcAnaSize ? addMultiProcAnaSizeContent : addAnaSizeContent,
            null,
            null,
            true
          )
        : ''}
      {/* サイズ板厚 */}
      {isSizeItaatsu
        ? commonModal(
            isSizeItaatsu,
            addThicknessModalTitle,
            null,
            null,
            400,
            addData,
            closeAddModal,
            addSizeItaatsuContent,
            null,
            null,
            true
          )
        : ''}
      {/* mm板厚 */}
      {isMmItaatsu
        ? commonModal(
            isMmItaatsu,
            addThicknessModalTitle,
            null,
            null,
            400,
            addData,
            closeAddModal,
            isMultiProcAnaSize ? addMmMultiProcContent : addMmItaatsuContent,
            null,
            null,
            true
          )
        : ''}
    </>
  );
});

export default Device_KakouJikan;
